/******/ var __webpack_modules__ = ({

/***/ 2375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Rc: function() { return /* binding */ VariantSelectedEvent; },
/* harmony export */   fy: function() { return /* binding */ ThemeEvents; },
/* harmony export */   pu: function() { return /* binding */ VariantUpdateEvent; }
/* harmony export */ });
/* unused harmony exports CartAddEvent, CartUpdateEvent, CartErrorEvent, QuantitySelectorUpdateEvent, DiscountUpdateEvent, MediaStartedPlayingEvent, SlideshowSelectEvent, ZoomMediaSelectedEvent, MegaMenuHoverEvent, FilterUpdateEvent */
/**
 * @namespace ThemeEvents
 * @description A collection of theme-specific events that can be used to trigger and listen for changes anywhere in the theme.
 * @example
 * document.dispatchEvent(new VariantUpdateEvent(variant, sectionId, { html }));
 * document.addEventListener(ThemeEvents.variantUpdate, (e) => { console.log(e.detail.variant) });
 */
class ThemeEvents {
  /** @static @constant {string} Event triggered when a variant is selected */
  static variantSelected = 'variant:selected';
  /** @static @constant {string} Event triggered when a variant is changed */
  static variantUpdate = 'variant:update';
  /** @static @constant {string} Event triggered when the cart items or quantities are updated */
  static cartUpdate = 'cart:update';
  /** @static @constant {string} Event triggered when a cart update fails */
  static cartError = 'cart:error';
  /** @static @constant {string} Event triggered when a media (video, 3d model) is loaded */
  static mediaStartedPlaying = 'media:started-playing';
  // Event triggered when quantity-selector value is changed
  static quantitySelectorUpdate = 'quantity-selector:update';
  /** @static @constant {string} Event triggered when a predictive search is expanded */
  static megaMenuHover = 'megaMenu:hover';
  /** @static @constant {string} Event triggered when a zoom dialog media is selected */
  static zoomMediaSelected = 'zoom-media:selected';
  /** @static @constant {string} Event triggered when a discount is applied */
  static discountUpdate = 'discount:update';
  /** @static @constant {string} Event triggered when changing collection filters */
  static FilterUpdate = 'filter:update';
}

/**
 * Event fired when a variant is selected
 * @extends {Event}
 */
class VariantSelectedEvent extends Event {
  /**
   * Creates a new VariantSelectedEvent
   * @param {Object} resource - The new variant object
   * @param {string} resource.id - The option value id
   */
  constructor(resource) {
    super(ThemeEvents.variantSelected, {
      bubbles: true
    });
    this.detail = {
      resource
    };
  }
}

/**
 * Event fired after a variant is updated
 * @extends {Event}
 */
class VariantUpdateEvent extends Event {
  /**
  * Creates a new VariantUpdateEvent
  * @param {Object} resource - The new variant object
  * @param {string} resource.id - The id of the variant
  * @param {boolean} resource.available - Whether the variant is available
  * @param {boolean} resource.inventory_management - Whether the variant has inventory management
  * @param {string} [resource.sku] - The SKU of the variant
  * @param {Object} [resource.featured_media] - The featured media of the variant
  * @param {string} [resource.featured_media.id] - The id of the featured media
  * @param {Object} [resource.featured_media.preview_image] - The preview image of the featured media
  * @param {string} [resource.featured_media.preview_image.src] - The src URL of the preview image
  * @param {string} sourceId - The id of the element the action was triggered from
  * @param {Object} data - Additional event data
  * @param {Document} data.html - The new document fragment for the variant
  * @param {string} data.productId - The product ID of the updated variant, used to ensure the correct product form is updated
  * @param {Object} [data.newProduct] - If a new product was loaded as part of the variant update (combined listing)
  * @param {string} data.newProduct.id - The id of the new product
  * @param {string} data.newProduct.url - The url of the new product
  */
  constructor(resource, sourceId, data) {
    super(ThemeEvents.variantUpdate, {
      bubbles: true
    });
    this.detail = {
      resource: resource || null,
      sourceId,
      data: {
        html: data.html,
        productId: data.productId,
        newProduct: data.newProduct
      }
    };
  }
}

/**
 * Event class for cart additions
 * @extends {Event}
 */
class CartAddEvent extends Event {
  /**
  * Creates a new CartAddEvent
  * @param {Object} [resource] - The new cart object
  * @param {string} [sourceId] - The id of the element the action was triggered from
  * @param {Object} [data] - Additional event data
  * @param {boolean} [data.didError] - Whether the cart operation failed
  * @param {string} [data.source] - The source of the cart update
  * @param {string} [data.productId] - The id of the product card that was updated
  * @param {number} [data.itemCount] - The number of items in the cart
  * @param {string} [data.variantId] - The id of the product variant that was added
  * @param {Record<string, string>} [data.sections] - The sections affected by the cart operation
  */
  constructor(resource, sourceId, data) {
    super(CartAddEvent.eventName, {
      bubbles: true
    });
    this.detail = {
      resource,
      sourceId,
      data: {
        ...data
      }
    };
  }
  static eventName = ThemeEvents.cartUpdate;
}

/**
 * Event class for cart updates
 * @extends {Event}
 */
class CartUpdateEvent extends Event {
  /**
  * Creates a new CartUpdateEvent
  * @param {Object} resource - The new cart object
  * @param {string} sourceId - The id of the element the action was triggered from
  * @param {Object} [data] - Additional event data
  * @param {boolean} [data.didError] - Whether the cart operation failed
  * @param {string} [data.source] - The source of the cart update
  * @param {string} [data.productId] - The id of the product card that was updated
  * @param {number} [data.itemCount] - The number of items in the cart
  * @param {string} [data.variantId] - The id of the product variant that was updated
  * @param {Record<string, string>} [data.sections] - The sections affected by the cart operation
  */
  constructor(resource, sourceId, data) {
    super(ThemeEvents.cartUpdate, {
      bubbles: true
    });
    this.detail = {
      resource,
      sourceId,
      data: {
        ...data
      }
    };
  }
}

/**
 * Event class for cart errors
 * @extends {Event}
 */
class CartErrorEvent extends Event {
  /**
  * Creates a new CartErrorEvent
  * @param {string} sourceId - The id of the element the action was triggered from
  * @param {string} message - A message from the server response
  * @param {Object} description - Description from the server response
  * @param {Object} errors - Errors from the server response
  */
  constructor(sourceId, message, description, errors) {
    super(ThemeEvents.cartError, {
      bubbles: true
    });
    this.detail = {
      sourceId,
      data: {
        message,
        errors,
        description
      }
    };
  }
}

/**
 * Event class for quantity-selector updates
 * @extends {Event}
 */
class QuantitySelectorUpdateEvent extends Event {
  /**
  * Creates a new QuantitySelectorUpdateEvent
  * @param {number} quantity - Quantity value
  * @param {number} [cartLine] - The id of the updated cart line
  */
  constructor(quantity, cartLine) {
    super(ThemeEvents.quantitySelectorUpdate, {
      bubbles: true
    });
    this.detail = {
      quantity,
      cartLine
    };
  }
}

/**
 * Event class for quantity-selector updates
 * @extends {Event}
 */
class DiscountUpdateEvent extends Event {
  /**
  * Creates a new DiscountUpdateEvent
  * @param {Object} resource - The new cart object
  * @param {string} sourceId - The id of the element the action was triggered from
  */
  constructor(resource, sourceId) {
    super(ThemeEvents.discountUpdate, {
      bubbles: true
    });
    this.detail = {
      resource,
      sourceId
    };
  }
}

/**
 * Event class for media playback starts
 * @extends {Event}
 */
class MediaStartedPlayingEvent extends Event {
  /**
  * Creates a new MediaStartedPlayingEvent
  * @param {HTMLElement} resource - The element containing the video that emitted the event
  */
  constructor(resource) {
    super(ThemeEvents.mediaStartedPlaying, {
      bubbles: true
    });
    this.detail = {
      resource
    };
  }
}

/**
 * @typedef {Object} SlideshowSelectEventData
 * @property {number} index
 * @property {string | null} id
 * @property {Element} slide
 * @property {number} previousIndex
 * @property {boolean} userInitiated
 * @property {'select' | 'scroll' | 'drag'} trigger
 */

class SlideshowSelectEvent extends Event {
  /**  @param {SlideshowSelectEventData} data */
  constructor(data) {
    super(SlideshowSelectEvent.eventName, {
      bubbles: true
    });
    this.detail = data;
  }

  /** @type {SlideshowSelectEventData} */
  detail;
  static eventName = 'slideshow:select';
}

/**
 * Event class for zoom dialog media selection
 * @extends {Event}
 */
class ZoomMediaSelectedEvent extends Event {
  /**
  * Creates a new ZoomMediaSelectedEvent
  * @param {number} index - The index of the selected media
  */
  constructor(index) {
    super(ThemeEvents.zoomMediaSelected, {
      bubbles: true
    });
    this.detail = {
      index
    };
  }
}

/**
 * Event class for mega menu hover being hovered over
 * @extends {Event}
 */
class MegaMenuHoverEvent extends Event {
  constructor() {
    super(ThemeEvents.megaMenuHover, {
      bubbles: true
    });
  }
}

/** Event class for facet filtering updates */
class FilterUpdateEvent extends Event {
  /** @param {URLSearchParams} queryParams */
  constructor(queryParams) {
    super(ThemeEvents.FilterUpdate, {
      bubbles: true
    });
    this.detail = {
      queryParams
    };
  }
  shouldShowClearAll() {
    return [...this.detail.queryParams.entries()].filter(([key]) => key.startsWith('filter.')).length > 0;
  }
}

/***/ }),

/***/ 2443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   u: function() { return /* binding */ Component; }
/* harmony export */ });
/* unused harmony export DeclarativeShadowElement */
/* harmony import */ var _theme_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6816);


/*
 * Declarative shadow DOM is only initialized on the initial render of the page.
 * If the component is mounted after the browser finishes the initial render,
 * the shadow root needs to be manually hydrated.
 */
class DeclarativeShadowElement extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot) {
      const template = this.querySelector(':scope > template[shadowrootmode="open"]');
      if (!(template instanceof HTMLTemplateElement)) return;
      const shadow = this.attachShadow({
        mode: 'open'
      });
      shadow.append(template.content.cloneNode(true));
    }
  }
}

/**
 * @typedef {Record<string, Element | Element[] | undefined>} Refs
 */

/**
 * @template {Refs} T
 * @typedef {T & Refs} RefsType
 */

/**
 * Base class that powers our custom web components.
 *
 * Manages references to child elements with `ref` attributes and sets up mutation observers to keep
 * the refs updated when the DOM changes. Also handles declarative event listeners using.
 *
 * @template {Refs} [T=Refs]
 * @extends {DeclarativeShadowElement}
 */
class Component extends DeclarativeShadowElement {
  /**
  * An object holding references to child elements with `ref` attributes.
  *
  * @type {RefsType<T>}
  */
  refs = (/** @type {RefsType<T>} */{});

  /**
  * An array of required refs. If a ref is not found, an error will be thrown.
  *
  * @type {string[] | undefined}
  */
  requiredRefs;

  /**
  * Gets the root node of the component, which is either its shadow root or the component itself.
  *
  * @returns {(ShadowRoot | Component<T>)[]} The root nodes.
  */
  get roots() {
    return this.shadowRoot ? [this, this.shadowRoot] : [this];
  }

  /**
  * Called when the element is connected to the document's DOM.
  *
  * Initializes event listeners and refs.
  */
  connectedCallback() {
    super.connectedCallback();
    registerEventListeners();
    this.#updateRefs();
    (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_0__/* .requestIdleCallback */ .BB)(() => {
      for (const root of this.roots) {
        this.#mutationObserver.observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['ref'],
          attributeOldValue: true
        });
      }
    });
  }

  /**
  * Called when the element is re-rendered by the Section Rendering API.
  */
  updatedCallback() {
    this.#mutationObserver.takeRecords();
    this.#updateRefs();
  }

  /**
  * Called when the element is disconnected from the document's DOM.
  *
  * Disconnects the mutation observer.
  */
  disconnectedCallback() {
    this.#mutationObserver.disconnect();
  }

  /**
  * Updates the `refs` object by querying all descendant elements with `ref` attributes and storing references to them.
  *
  * This method is called to keep the `refs` object in sync with the DOM.
  */
  #updateRefs() {
    const refs = /** @type any */{};
    const elements = this.roots.reduce((acc, root) => {
      for (const element of root.querySelectorAll('[ref]')) {
        if (!this.#isDescendant(element)) continue;
        acc.add(element);
      }
      return acc;
    }, /** @type {Set<Element>} */new Set());
    for (const ref of elements) {
      const refName = ref.getAttribute('ref') ?? '';
      const isArray = refName.endsWith('[]');
      const path = isArray ? refName.slice(0, -2) : refName;
      if (isArray) {
        const array = Array.isArray(refs[path]) ? refs[path] : [];
        array.push(ref);
        refs[path] = array;
      } else {
        const existing = refs[path];
        const refIsDirectChild = ref.parentElement === this;
        const existingIsDirectChild = existing?.parentElement === this;
        if (existing !== undefined) {
          if (existingIsDirectChild && !refIsDirectChild) continue;
          if (!existingIsDirectChild && refIsDirectChild) {
            refs[path] = ref;
            continue;
          }
        }
        refs[path] = ref;
      }
    }
    if (this.requiredRefs?.length) {
      for (const ref of this.requiredRefs) {
        if (!(ref in refs)) {
          throw new MissingRefError(ref, this);
        }
      }
    }
    this.refs = /** @type {RefsType<T>} */refs;
  }

  /**
  * MutationObserver instance to observe changes in the component's DOM subtree and update refs accordingly.
  *
  * @type {MutationObserver}
  */
  #mutationObserver = new MutationObserver(mutations => {
    if (mutations.some(m => m.type === 'attributes' && this.#isDescendant(m.target) || m.type === 'childList' && [...m.addedNodes, ...m.removedNodes].some(this.#isDescendant))) {
      this.#updateRefs();
    }
  });

  /**
  * Checks if a given node is a descendant of this component.
  *
  * @param {Node} node - The node to check.
  * @returns {boolean} True if the node is a descendant of this component.
  */
  #isDescendant = node => getClosestComponent(getAncestor(node)) === this;
}

/**
 * Get the ancestor of a given node.
 *
 * @param {Node} node - The node to get the ancestor of.
 * @returns {Node | null} The ancestor of the node or null if none is found.
 */
function getAncestor(node) {
  if (node.parentNode) return node.parentNode;
  const root = node.getRootNode();
  if (root instanceof ShadowRoot) return root.host;
  return null;
}

/**
 * Recursively finds the closest ancestor that is an instance of `Component`.
 *
 * @param {Node | null} node - The starting node to search from.
 * @returns {HTMLElement | null} The closest ancestor `Component` instance or null if none is found.
 */
function getClosestComponent(node) {
  if (!node) return null;
  if (node instanceof Component) return node;
  if (node instanceof HTMLElement && node.tagName.toLowerCase().endsWith('-component')) return node;
  const ancestor = getAncestor(node);
  if (ancestor) return getClosestComponent(ancestor);
  return null;
}

/**
 * Initializes the event listeners for custom event handling.
 *
 * Sets up event listeners for specified events and delegates the handling of those events
 * to methods defined on the closest `Component` instance, based on custom attributes.
 */
let initialized = false;
function registerEventListeners() {
  if (initialized) return;
  initialized = true;
  const events = ['click', 'change', 'select', 'focus', 'blur', 'submit', 'input', 'keydown', 'keyup', 'toggle'];
  const shouldBubble = ['focus', 'blur'];
  const expensiveEvents = ['pointerenter', 'pointerleave'];
  for (const eventName of [...events, ...expensiveEvents]) {
    const attribute = `on:${eventName}`;
    document.addEventListener(eventName, event => {
      const element = getElement(event);
      if (!element) return;
      const proxiedEvent = event.target !== element ? new Proxy(event, {
        get(target, property) {
          if (property === 'target') return element;
          const value = Reflect.get(target, property);
          if (typeof value === 'function') {
            return value.bind(target);
          }
          return value;
        }
      }) : event;
      const value = element.getAttribute(attribute) ?? '';
      let [selector, method] = value.split('/');
      // Extract the last segment of the attribute value delimited by `?` or `/`
      // Do not use lookback for Safari 16.0 compatibility
      const matches = value.match(/([\/\?][^\/\?]+)([\/\?][^\/\?]+)$/);
      const data = matches ? matches[2] : null;
      const instance = selector ? selector.startsWith('#') ? document.querySelector(selector) : element.closest(selector) : getClosestComponent(element);
      if (!(instance instanceof Component) || !method) return;
      method = method.replace(/\?.*/, '');
      const callback = /** @type {any} */instance[method];
      if (typeof callback === 'function') {
        try {
          /** @type {(Event | Data)[]} */
          const args = [proxiedEvent];
          if (data) args.unshift(parseData(data));
          callback.call(instance, ...args);
        } catch (error) {
          console.error(error);
        }
      }
    }, {
      capture: true
    });
  }

  /** @param {Event} event */
  function getElement(event) {
    const target = event.composedPath?.()[0] ?? event.target;
    if (!(target instanceof Element)) return;
    if (target.hasAttribute(`on:${event.type}`)) {
      return target;
    }
    if (expensiveEvents.includes(event.type)) {
      return null;
    }
    return event.bubbles || shouldBubble.includes(event.type) ? target.closest(`[on\\:${event.type}]`) : null;
  }
}

/**
 * Parses a string to extract data based on a delimiter.
 *
 * @param {string} str - The string to parse.
 * @returns {Object|Array<string|number>|string} The parsed data.
 */
function parseData(str) {
  const delimiter = str[0];
  const data = str.slice(1);
  return delimiter === '?' ? Object.fromEntries(Array.from(new URLSearchParams(data).entries()).map(([key, value]) => [key, parseValue(value)])) : parseValue(data);
}

/**
 * @typedef {Object|Array<string|number>|string} Data
 */

/**
 * Parses a string value to its appropriate type.
 *
 * @param {string} str - The string to parse.
 * @returns {Data} The parsed value.
 */
function parseValue(str) {
  if (str === 'true') return true;
  if (str === 'false') return false;
  const maybeNumber = Number(str);
  if (!isNaN(maybeNumber) && str.trim() !== '') return maybeNumber;
  return str;
}

/**
 * Throws a formatted error when a required ref is not found in the component.
 */
class MissingRefError extends Error {
  /**
  * @param {string} ref
  * @param {Component} component
  */
  constructor(ref, component) {
    super(`Required ref "${ref}" not found in component ${component.tagName.toLowerCase()}`);
  }
}

/***/ }),

/***/ 4919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export default */
/* harmony import */ var _theme_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2443);
/* harmony import */ var _theme_events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2375);
/* harmony import */ var _theme_morph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9314);
/* harmony import */ var _theme_utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6816);





/**
 * @typedef {object} VariantPickerRefs
 * @property {HTMLFieldSetElement[]} fieldsets – The fieldset elements.
 */

/**
 * A custom element that manages a variant picker.
 *
 * @template {import('@theme/component').Refs} [TRefs=VariantPickerRefs]
 * @extends Component<TRefs>
 */
class VariantPicker extends _theme_component__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .u {
  /** @type {string | undefined} */
  #pendingRequestUrl;

  /** @type {AbortController | undefined} */
  #abortController;

  /** @type {AbortController | undefined} */
  #standaloneFetchController;

  /** @type {number[][]} */
  #checkedIndices = [];

  /** @type {HTMLInputElement[][]} */
  #radios = [];
  #resizeObserver = new _theme_utilities__WEBPACK_IMPORTED_MODULE_3__/* .ResizeNotifier */ .LC(() => this.updateVariantPickerCss());
  connectedCallback() {
    super.connectedCallback();
    const fieldsets = /** @type {HTMLFieldSetElement[]} */this.refs.fieldsets || [];
    fieldsets.forEach(fieldset => {
      const radios = Array.from(fieldset?.querySelectorAll('input') ?? []);
      this.#radios.push(radios);
      const initialCheckedIndex = radios.findIndex(radio => radio.dataset.currentChecked === 'true');
      if (initialCheckedIndex !== -1) {
        this.#checkedIndices.push([initialCheckedIndex]);
      }
    });
    this.addEventListener('change', this.variantChanged.bind(this));
    this.addEventListener('change', this.#handleNavigateOnChange);
    this.#resizeObserver.observe(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver.disconnect();
    this.removeEventListener('change', this.#handleNavigateOnChange);
  }

  /**
  * Handles change events on selects with data-navigate-on-change.
  * Navigates to the URL stored in the selected option value.
  *
  * @param {Event} event
  */
  #handleNavigateOnChange = event => {
    if (!(event.target instanceof HTMLSelectElement)) return;
    if (!('navigateOnChange' in event.target.dataset)) return;
    if (event.target.value) window.location.href = event.target.value;
  };

  /**
  * Handles the variant change event.
  * @param {Event} event - The variant change event.
  */
  variantChanged(event) {
    if (!(event.target instanceof HTMLElement)) return;
    if (event.target instanceof HTMLSelectElement && 'navigateOnChange' in event.target.dataset) return;
    const selectedOption = event.target instanceof HTMLSelectElement ? event.target.options[event.target.selectedIndex] : event.target;
    if (!selectedOption) return;
    this.updateSelectedOption(event.target);
    if (this.dataset.standalone === 'true') {
      const productUrl = (this.dataset.productUrl || '').split('?')[0];
      if (!productUrl) {
        this.#handleStandaloneVariantChange();
        return;
      }
      let optionIds = [];
      try {
        optionIds = this.selectedOptionsValues;
      } catch {
        this.#handleStandaloneVariantChange();
        return;
      }
      if (optionIds.length > 0) {
        const requestUrl = `${productUrl}?section_id=section-rendering-rupture-merch-card&option_values=${optionIds.join(',')}`;
        this.#standaloneFetchController?.abort();
        this.#standaloneFetchController = new AbortController();
        fetch(requestUrl, {
          signal: this.#standaloneFetchController.signal
        }).then(res => res.text()).then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newCard = html.querySelector('.rupture-merch-merchandising-modal__card');
          const currentCard = this.closest('.rupture-merch-merchandising-modal__card');
          if (newCard && currentCard) {
            (0,_theme_morph__WEBPACK_IMPORTED_MODULE_2__/* .morph */ .r)(currentCard, newCard, {
              ..._theme_morph__WEBPACK_IMPORTED_MODULE_2__/* .MORPH_OPTIONS */ .I,
              getNodeKey: node => node instanceof HTMLElement ? node.dataset.key : undefined
            });
          } else {
            this.#handleStandaloneVariantChange();
          }
        }).catch(err => {
          if (err.name !== 'AbortError') this.#handleStandaloneVariantChange();
        });
      } else {
        this.#handleStandaloneVariantChange();
      }
      return;
    }
    this.dispatchEvent(new _theme_events__WEBPACK_IMPORTED_MODULE_1__/* .VariantSelectedEvent */ .Rc({
      id: selectedOption.dataset.optionValueId ?? ''
    }));
    const isOnProductPage = this.dataset.templateProductMatch === 'true' && !event.target.closest('product-card') && !event.target.closest('quick-add-dialog');

    // Morph the entire main content for combined listings child products, because changing the product
    // might also change other sections depending on recommendations, metafields, etc.
    const currentUrl = this.dataset.productUrl?.split('?')[0];
    const newUrl = selectedOption.dataset.connectedProductUrl;
    const loadsNewProduct = isOnProductPage && !!newUrl && newUrl !== currentUrl;
    const isOnFeaturedProductSection = Boolean(this.closest('featured-product-information'));
    const morphElementSelector = loadsNewProduct ? 'main' : isOnFeaturedProductSection ? 'featured-product-information' : undefined;
    this.fetchUpdatedSection(this.buildRequestUrl(selectedOption), morphElementSelector);
    const url = new URL(window.location.href);
    const variantId = selectedOption.dataset.variantId || null;
    if (isOnProductPage) {
      if (variantId) {
        url.searchParams.set('variant', variantId);
      } else {
        url.searchParams.delete('variant');
      }
    }

    // Change the path if the option is connected to another product via combined listing.
    if (loadsNewProduct) {
      url.pathname = newUrl;
    }
    if (url.href !== window.location.href) {
      (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_3__/* .yieldToMainThread */ .uT)().then(() => {
        history.replaceState({}, '', url.toString());
      });
    }
  }
  #handleStandaloneVariantChange() {
    const form = this.querySelector('.variant-picker__form');
    const jsonEl = this.querySelector('script[data-variants-json]');
    let variants = [];
    try {
      variants = jsonEl?.textContent ? JSON.parse(jsonEl.textContent) : [];
    } catch {
      variants = [];
    }
    let selectedValues = [];
    /** @type {string | null} */
    let dataVariantIdFromRadio = null;
    // Collect option containers: fieldsets (swatches/buttons) and dropdown divs, then sort by option index
    const fieldsetEls = Array.from(form?.querySelectorAll('fieldset[data-fieldset-index]') ?? []);
    const dropdownEls = Array.from(form?.querySelectorAll('.variant-option--dropdowns[data-fieldset-index]') ?? []);
    const sortByIndex = (/** @type {Element} */a, /** @type {Element} */b) => Number(a instanceof HTMLElement ? a.dataset.fieldsetIndex ?? 0 : 0) - Number(b instanceof HTMLElement ? b.dataset.fieldsetIndex ?? 0 : 0);
    const optionContainers = [...fieldsetEls, ...dropdownEls].sort(sortByIndex);
    selectedValues = optionContainers.map(container => {
      const fieldset = container instanceof HTMLFieldSetElement ? container : null;
      const select = container.querySelector?.('select.variant-option__select');
      if (fieldset) {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked instanceof HTMLInputElement) {
          if (checked.dataset.variantId) dataVariantIdFromRadio = checked.dataset.variantId;
          return checked.value;
        }
        return '';
      }
      if (select instanceof HTMLSelectElement) return select.value;
      return '';
    });
    const norm = (/** @type {string} */s) => String(s ?? '').trim().toLowerCase();
    let variant = variants.find((/** @type {{ option1?: string; option2?: string; option3?: string; id?: number }} */v) => {
      const vOpts = [v.option1, v.option2, v.option3].filter(Boolean);
      return vOpts.length === selectedValues.length && vOpts.every((opt, i) => norm(String(opt ?? '')) === norm(selectedValues[i] ?? ''));
    });
    if (!variant && dataVariantIdFromRadio) {
      variant = variants.find((/** @type {{ id?: number }} */v) => String(v.id) === String(dataVariantIdFromRadio));
    }
    const productId = this.dataset.productId ?? '';
    const card = this.closest('.rupture-merch-merchandising-modal__card');
    const productForm = card?.querySelector('product-form-component');
    const idInput = productForm?.querySelector('input[name="id"]');
    if (idInput instanceof HTMLInputElement) {
      idInput.value = variant ? String(variant.id) : '';
      idInput.disabled = !variant;
    }
    this.dispatchEvent(new _theme_events__WEBPACK_IMPORTED_MODULE_1__/* .VariantUpdateEvent */ .pu(variant ?? null, this.id || 'variant-picker-standalone', {
      html: (/** @type {Document} */ /** @type {unknown} */document.createDocumentFragment()),
      productId
    }));
  }

  /**
  * @typedef {object} FieldsetMeasurements
  * @property {HTMLFieldSetElement} fieldset
  * @property {number | undefined} currentIndex
  * @property {number | undefined} previousIndex
  * @property {number | undefined} currentWidth
  * @property {number | undefined} previousWidth
  */

  /**
  * Gets measurements for a single fieldset (read phase).
  * @param {number} fieldsetIndex
  * @returns {FieldsetMeasurements | null}
  */
  #getFieldsetMeasurements(fieldsetIndex) {
    const fieldsets = /** @type {HTMLFieldSetElement[]} */this.refs.fieldsets || [];
    const fieldset = fieldsets[fieldsetIndex];
    const checkedIndices = this.#checkedIndices[fieldsetIndex];
    const radios = this.#radios[fieldsetIndex];
    if (!radios || !checkedIndices || !fieldset) return null;
    const [currentIndex, previousIndex] = checkedIndices;
    return {
      fieldset,
      currentIndex,
      previousIndex,
      currentWidth: currentIndex !== undefined ? radios[currentIndex]?.parentElement?.offsetWidth : undefined,
      previousWidth: previousIndex !== undefined ? radios[previousIndex]?.parentElement?.offsetWidth : undefined
    };
  }

  /**
  * Applies measurements to a fieldset (write phase).
  * @param {FieldsetMeasurements} measurements
  */
  #applyFieldsetMeasurements({
    fieldset,
    currentWidth,
    previousWidth,
    currentIndex,
    previousIndex
  }) {
    if (currentWidth) {
      fieldset.style.setProperty('--pill-width-current', `${currentWidth}px`);
    } else if (currentIndex !== undefined) {
      fieldset.style.removeProperty('--pill-width-current');
    }
    if (previousWidth) {
      fieldset.style.setProperty('--pill-width-previous', `${previousWidth}px`);
    } else if (previousIndex !== undefined) {
      fieldset.style.removeProperty('--pill-width-previous');
    }
  }

  /**
  * Updates the fieldset CSS.
  * @param {number} fieldsetIndex - The fieldset index.
  */
  updateFieldsetCss(fieldsetIndex) {
    if (Number.isNaN(fieldsetIndex)) return;
    const measurements = this.#getFieldsetMeasurements(fieldsetIndex);
    if (measurements) {
      this.#applyFieldsetMeasurements(measurements);
    }
  }

  /**
  * Updates the selected option.
  * @param {string | Element} target - The target element.
  */
  updateSelectedOption(target) {
    if (typeof target === 'string') {
      const targetElement = this.querySelector(`[data-option-value-id="${target}"]`);
      if (!targetElement) throw new Error('Target element not found');
      target = targetElement;
    }
    if (target instanceof HTMLInputElement) {
      const fieldsetIndex = Number.parseInt(target.dataset.fieldsetIndex || '');
      const inputIndex = Number.parseInt(target.dataset.inputIndex || '');
      if (!Number.isNaN(fieldsetIndex) && !Number.isNaN(inputIndex)) {
        const fieldsets = /** @type {HTMLFieldSetElement[]} */this.refs.fieldsets || [];
        const fieldset = fieldsets[fieldsetIndex];
        const checkedIndices = this.#checkedIndices[fieldsetIndex];
        const radios = this.#radios[fieldsetIndex];
        if (radios && checkedIndices && fieldset) {
          // Clear previous checked states
          const [currentIndex, previousIndex] = checkedIndices;
          if (currentIndex !== undefined && radios[currentIndex]) {
            radios[currentIndex].dataset.previousChecked = 'false';
          }
          if (previousIndex !== undefined && radios[previousIndex]) {
            radios[previousIndex].dataset.previousChecked = 'false';
          }

          // Update checked indices array - keep only the last 2 selections
          checkedIndices.unshift(inputIndex);
          checkedIndices.length = Math.min(checkedIndices.length, 2);

          // Update the new states
          const newCurrentIndex = checkedIndices[0]; // This is always inputIndex
          const newPreviousIndex = checkedIndices[1]; // This might be undefined

          // newCurrentIndex is guaranteed to exist since we just added it
          if (newCurrentIndex !== undefined && radios[newCurrentIndex]) {
            radios[newCurrentIndex].dataset.currentChecked = 'true';
          }
          if (newPreviousIndex !== undefined && radios[newPreviousIndex]) {
            radios[newPreviousIndex].dataset.previousChecked = 'true';
            radios[newPreviousIndex].dataset.currentChecked = 'false';
          }
          this.updateFieldsetCss(fieldsetIndex);
        }
      }
      target.checked = true;
    }
    if (target instanceof HTMLSelectElement) {
      const newValue = target.value;
      const newSelectedOption = Array.from(target.options).find(option => option.value === newValue);
      if (!newSelectedOption) throw new Error('Option not found');
      for (const option of target.options) {
        option.removeAttribute('selected');
      }
      newSelectedOption.setAttribute('selected', 'selected');
    }
  }

  /**
  * Builds the request URL.
  * @param {HTMLElement} selectedOption - The selected option.
  * @param {string | null} [source] - The source.
  * @param {string[]} [sourceSelectedOptionsValues] - The source selected options values.
  * @returns {string} The request URL.
  */
  buildRequestUrl(selectedOption, source = null, sourceSelectedOptionsValues = []) {
    // this productUrl and pendingRequestUrl will be useful for the support of combined listing. It is used when a user changes variant quickly and those products are using separate URLs (combined listing).
    // We create a new URL and abort the previous fetch request if it's still pending.
    let productUrl = selectedOption.dataset.connectedProductUrl || this.#pendingRequestUrl || this.dataset.productUrl;
    this.#pendingRequestUrl = productUrl;
    const params = [];
    const viewParamValue = (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_3__/* .getViewParameterValue */ .oG)();

    // preserve view parameter, if it exists, for alternative product view testing
    if (viewParamValue) params.push(`view=${viewParamValue}`);
    if (this.selectedOptionsValues.length && !source) {
      params.push(`option_values=${this.selectedOptionsValues.join(',')}`);
    } else if (source === 'product-card') {
      if (this.selectedOptionsValues.length) {
        params.push(`option_values=${sourceSelectedOptionsValues.join(',')}`);
      } else {
        params.push(`option_values=${selectedOption.dataset.optionValueId}`);
      }
    }

    // If variant-picker is a child of some specific sections, we need to append section_id=xxxx to the URL
    const SECTION_ID_MAP = {
      'quick-add-component': 'section-rendering-product-card',
      'swatches-variant-picker-component': 'section-rendering-product-card',
      'featured-product-information': this.closest('featured-product-information')?.id
    };
    const closestSectionId = /** @type {keyof typeof SECTION_ID_MAP} | undefined */
    Object.keys(SECTION_ID_MAP).find(sectionId => this.closest(sectionId));
    if (closestSectionId) {
      if (productUrl?.includes('?')) {
        productUrl = productUrl.split('?')[0];
      }
      return `${productUrl}?section_id=${SECTION_ID_MAP[closestSectionId]}&${params.join('&')}`;
    }
    return `${productUrl}?${params.join('&')}`;
  }

  /**
  * Fetches the updated section.
  * @param {string} requestUrl - The request URL.
  * @param {string} [morphElementSelector] - The selector of the element to be morphed. By default, only the variant picker is morphed.
  */
  fetchUpdatedSection(requestUrl, morphElementSelector) {
    // We use this to abort the previous fetch request if it's still pending.
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    fetch(requestUrl, {
      signal: this.#abortController.signal
    }).then(response => response.text()).then(responseText => {
      this.#pendingRequestUrl = undefined;
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      // Defer is only useful for the initial rendering of the page. Remove it here.
      html.querySelector('overflow-list[defer]')?.removeAttribute('defer');
      const textContent = html.querySelector(`variant-picker script[type="application/json"]`)?.textContent;
      if (!textContent) return;
      let newProduct;
      if (morphElementSelector === 'main') {
        this.updateMain(html);
      } else if (morphElementSelector) {
        this.updateElement(html, morphElementSelector);
      } else {
        newProduct = this.updateVariantPicker(html);
      }

      // Dispatch for all paths so product-form-component can reset #variantChangeInProgress
      if (this.selectedOptionId) {
        this.dispatchEvent(new _theme_events__WEBPACK_IMPORTED_MODULE_1__/* .VariantUpdateEvent */ .pu(JSON.parse(textContent), this.selectedOptionId, {
          html,
          productId: this.dataset.productId ?? '',
          newProduct
        }));
      }
    }).catch(error => {
      if (error.name === 'AbortError') {
        console.warn('Fetch aborted by user');
      } else {
        console.error(error);
      }
    });
  }

  /**
  * @typedef {Object} NewProduct
  * @property {string} id
  * @property {string} url
  */

  /**
  * Re-renders the variant picker.
  * @param {Document | Element} newHtml - The new HTML.
  * @returns {NewProduct | undefined} Information about the new product if it has changed, otherwise undefined.
  */
  updateVariantPicker(newHtml) {
    /** @type {NewProduct | undefined} */
    let newProduct;
    const newVariantPickerSource = newHtml.querySelector(this.tagName.toLowerCase());
    if (!newVariantPickerSource) {
      throw new Error('No new variant picker source found');
    }

    // For combined listings, the product might have changed, so update the related data attribute.
    if (newVariantPickerSource instanceof HTMLElement) {
      const newProductId = newVariantPickerSource.dataset.productId;
      const newProductUrl = newVariantPickerSource.dataset.productUrl;
      if (newProductId && newProductUrl && this.dataset.productId !== newProductId) {
        newProduct = {
          id: newProductId,
          url: newProductUrl
        };
      }
      this.dataset.productId = newProductId;
      this.dataset.productUrl = newProductUrl;
    }
    (0,_theme_morph__WEBPACK_IMPORTED_MODULE_2__/* .morph */ .r)(this, newVariantPickerSource, {
      ..._theme_morph__WEBPACK_IMPORTED_MODULE_2__/* .MORPH_OPTIONS */ .I,
      getNodeKey: node => {
        if (!(node instanceof HTMLElement)) return undefined;
        const key = node.dataset.key;
        return key;
      }
    });
    this.updateVariantPickerCss();
    return newProduct;
  }
  updateVariantPickerCss() {
    const fieldsets = /** @type {HTMLFieldSetElement[]} */this.refs.fieldsets || [];

    // Batch all reads first across all fieldsets to avoid layout thrashing
    const measurements = fieldsets.map((_, index) => this.#getFieldsetMeasurements(index)).filter(m => m !== null);

    // Batch all writes after all reads
    for (const measurement of measurements) {
      this.#applyFieldsetMeasurements(measurement);
    }
  }

  /**
  * Re-renders the desired element.
  * @param {Document} newHtml - The new HTML.
  * @param {string} elementSelector - The selector of the element to re-render.
  */
  updateElement(newHtml, elementSelector) {
    const element = this.closest(elementSelector);
    const newElement = newHtml.querySelector(elementSelector);
    if (!element || !newElement) {
      throw new Error(`No new element source found for ${elementSelector}`);
    }
    (0,_theme_morph__WEBPACK_IMPORTED_MODULE_2__/* .morph */ .r)(element, newElement);
  }

  /**
  * Re-renders the entire main content.
  * @param {Document} newHtml - The new HTML.
  */
  updateMain(newHtml) {
    const main = document.querySelector('main');
    const newMain = newHtml.querySelector('main');
    if (!main || !newMain) {
      throw new Error('No new main source found');
    }
    (0,_theme_morph__WEBPACK_IMPORTED_MODULE_2__/* .morph */ .r)(main, newMain);
  }

  /**
  * Gets the selected option.
  * @returns {HTMLInputElement | HTMLOptionElement | undefined} The selected option.
  */
  get selectedOption() {
    const selectedOption = this.querySelector('select option[selected], fieldset input:checked');
    if (!(selectedOption instanceof HTMLInputElement || selectedOption instanceof HTMLOptionElement)) {
      return undefined;
    }
    return selectedOption;
  }

  /**
  * Gets the selected option ID.
  * @returns {string | undefined} The selected option ID.
  */
  get selectedOptionId() {
    const {
      selectedOption
    } = this;
    if (!selectedOption) return undefined;
    const {
      optionValueId
    } = selectedOption.dataset;
    if (!optionValueId) {
      throw new Error('No option value ID found');
    }
    return optionValueId;
  }

  /**
  * Gets the selected options values.
  * @returns {string[]} The selected options values.
  */
  get selectedOptionsValues() {
    /** @type HTMLElement[] */
    const selectedOptions = Array.from(this.querySelectorAll('select option[selected], fieldset input:checked'));
    return selectedOptions.map(option => {
      const {
        optionValueId
      } = option.dataset;
      if (!optionValueId) throw new Error('No option value ID found');
      return optionValueId;
    });
  }
}
if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}

/***/ }),

/***/ 6816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $6: function() { return /* binding */ onAnimationEnd; },
/* harmony export */   BB: function() { return /* binding */ requestIdleCallback; },
/* harmony export */   GO: function() { return /* binding */ mediaQueryLarge; },
/* harmony export */   LC: function() { return /* binding */ ResizeNotifier; },
/* harmony export */   O: function() { return /* binding */ getIOSVersion; },
/* harmony export */   g1: function() { return /* binding */ isMobileBreakpoint; },
/* harmony export */   lm: function() { return /* binding */ isClickedOutside; },
/* harmony export */   oG: function() { return /* binding */ getViewParameterValue; },
/* harmony export */   sg: function() { return /* binding */ debounce; },
/* harmony export */   uT: function() { return /* binding */ yieldToMainThread; }
/* harmony export */ });
/* unused harmony exports isLowPowerDevice, supportsViewTransitions, viewTransition, startViewTransition, fetchConfig, throttle, prefersReducedMotion, normalizeString, onDocumentLoaded, onDocumentReady, removeWillChangeOnAnimationEnd, isPointWithinElement, isDesktopBreakpoint, isTouchDevice, clamp, center, start, closest, preventDefault, getVisibleElements, preloadImage, TextComponent, resetShimmer, changeMetaThemeColor, parseIntOrDefault, scheduler, oncePerEditorSession, setHeaderMenuStyle, calculateHeaderGroupHeight, updateAllHeaderCustomProperties */
/**
 * Request an idle callback or fallback to setTimeout
 * @returns {function} The requestIdleCallback function
 */
const requestIdleCallback = typeof window.requestIdleCallback == 'function' ? window.requestIdleCallback : setTimeout;

/**
 * Returns a promise that resolves after yielding to the main thread.
 * @see https://web.dev/articles/optimize-long-tasks#scheduler-yield
 */
const yieldToMainThread = () => {
  if ('yield' in scheduler) {
    // @ts-ignore - TypeScript doesn't recognize the yield method yet.
    return scheduler.yield();
  }
  return new Promise(resolve => {
    requestAnimationFrame(() => {
      setTimeout(resolve, 0);
    });
  });
};

/**
 * Tells if we are on a low power device based on the number of CPU cores and RAM
 * @returns {boolean} True if the device is a low power device, false otherwise
 */
function isLowPowerDevice() {
  return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
}

/**
 * Check if the browser supports View Transitions API
 * @returns {boolean} True if the browser supports View Transitions API, false otherwise
 */
function supportsViewTransitions() {
  return typeof document.startViewTransition === 'function';
}

/**
 * The current view transition
 * @type {{ current: Promise<void> | undefined }}
 */
const viewTransition = {
  current: undefined
};

/**
 * Functions to run when a view transition of a given type is started
 * @type {{ [key: string]: () => Promise<(() => void) | undefined> }}
 */
const viewTransitionTypes = {
  'product-grid': async () => {
    const grid = document.querySelector('.product-grid');
    const productCards = /** @type {HTMLElement[]} */[...document.querySelectorAll('.product-grid .product-grid__item')];
    if (!grid || !productCards.length) return;
    await new Promise(resolve => requestIdleCallback(() => {
      const cardsToAnimate = getCardsToAnimate(grid, productCards);
      productCards.forEach((card, index) => {
        if (index < cardsToAnimate) {
          card.style.setProperty('view-transition-name', `product-card-${card.dataset.productId}`);
        } else {
          card.style.setProperty('content-visibility', 'hidden');
        }
      });
      resolve(null);
    }));
    return () => productCards.forEach(card => {
      card.style.removeProperty('view-transition-name');
      card.style.removeProperty('content-visibility');
    });
  }
};

/**
 * Starts a view transition
 * @param {() => void} callback The callback to call when the view transition starts
 * @param {string[]} [types] The types of view transition to use
 * @returns {Promise<void>} A promise that resolves when the view transition finishes
 */
function startViewTransition(callback, types) {
  // Check if the API is supported and transitions are desired
  if (!supportsViewTransitions() || isLowPowerDevice() || prefersReducedMotion()) {
    callback();
    return Promise.resolve();
  }

  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async resolve => {
    let cleanupFunctions = [];
    if (types) {
      for (const type of types) {
        if (viewTransitionTypes[type]) {
          const cleanupFunction = await viewTransitionTypes[type]();
          if (cleanupFunction) cleanupFunctions.push(cleanupFunction);
        }
      }
    }
    const transition = document.startViewTransition(callback);
    if (!viewTransition.current) {
      viewTransition.current = transition.finished;
    }
    if (types) types.forEach(type => transition.types.add(type));
    transition.finished.then(() => {
      viewTransition.current = undefined;
      cleanupFunctions.forEach(cleanupFunction => cleanupFunction());
      resolve();
    });
  });
}

/**
 * @typedef {{ [key: string]: string | undefined }} Headers
 */

/**
 * @typedef {Object} FetchConfig
 * @property {string} method
 * @property {Headers} headers
 * @property {string | FormData | undefined} [body]
 */

/**
 * Creates a fetch configuration object
 * @param {string} [type] The type of response to expect
 * @param {Object} [config] The config of the request
 * @param {FetchConfig['body']} [config.body] The body of the request
 * @param {FetchConfig['headers']} [config.headers] The headers of the request
 * @returns {RequestInit} The fetch configuration object
 */
function fetchConfig(type = 'json', config = {}) {
  /** @type {Headers} */
  const headers = {
    'Content-Type': 'application/json',
    Accept: `application/${type}`,
    ...config.headers
  };
  if (type === 'javascript') {
    headers['X-Requested-With'] = 'XMLHttpRequest';
    delete headers['Content-Type'];
  }
  return {
    method: 'POST',
    headers: (/** @type {HeadersInit} */headers),
    body: config.body
  };
}

/**
 * Creates a debounced function that delays calling the provided function (fn)
 * until after wait milliseconds have elapsed since the last time
 * the debounced function was invoked. The returned function has a .cancel()
 * method to cancel any pending calls.
 *
 * @template {(...args: any[]) => any} T
 * @param {T} fn The function to debounce
 * @param {number} wait The time (in milliseconds) to wait before calling fn
 * @returns {T & { cancel(): void }} A debounced version of fn with a .cancel() method
 */
function debounce(fn, wait) {
  /** @type {number | undefined} */
  let timeout;

  /** @param {...any} args */
  function debounced(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  }

  // Add the .cancel method:
  debounced.cancel = () => {
    clearTimeout(timeout);
  };
  return /** @type {T & { cancel(): void }} */debounced;
}

/**
 * Creates a throttled function that calls the provided function (fn) at most once per every wait milliseconds
 *
 * @template {(...args: any[]) => any} T
 * @param {T} fn The function to throttle
 * @param {number} delay The time (in milliseconds) to wait before calling fn
 * @returns {T & { cancel(): void }} A throttled version of fn with a .cancel() method
 */
function throttle(fn, delay) {
  let lastCall = 0;

  /** @param {...any} args */
  function throttled(...args) {
    const now = performance.now();
    // If the time since the last call exceeds the delay, execute the callback
    if (now - lastCall >= delay) {
      lastCall = now;
      fn.apply(this, args);
    }
  }
  throttled.cancel = () => {
    lastCall = performance.now();
  };
  return /** @type {T & { cancel(): void }} */throttled;
}

/**
 * A media query for reduced motion
 * @type {MediaQueryList}
 */
const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

/**
 * Check if the user prefers reduced motion
 * @returns {boolean} True if the user prefers reduced motion, false otherwise
 */
function prefersReducedMotion() {
  return reducedMotion.matches;
}

/**
 * Normalize a string
 * @param {string} str The string to normalize
 * @returns {string} The normalized string
 */
function normalizeString(str) {
  return str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
}

/**
 * Check if the document is ready/loaded and call the callback when it is.
 * @param {() => void} callback The function to call when the document is ready.
 */
function onDocumentLoaded(callback) {
  if (document.readyState === 'complete') {
    callback();
  } else {
    window.addEventListener('load', callback);
  }
}

/**
 * Check if the DOM is ready and call the callback when it is.
 * This fires when the DOM is fully parsed but before all resources are loaded.
 * @param {() => void} callback The function to call when the DOM is ready.
 */
function onDocumentReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
}

/**
 * Removes will-change from an element after an animation ends.
 * Intended to be used as an animationend event listener.
 * @param {AnimationEvent} event The animation event.
 */
function removeWillChangeOnAnimationEnd(event) {
  const target = event.target;
  if (target && target instanceof HTMLElement) {
    target.style.setProperty('will-change', 'unset');
    target.removeEventListener('animationend', removeWillChangeOnAnimationEnd);
  }
}

/**
 * Wait for all animations to finish before calling the callback.
 * @param {Element | Element[]} elements The element(s) whose animations to wait for.
 * @param {() => void} [callback] The function to call when all animations are finished.
 * @param {Object} [options] The options to pass to `Element.getAnimations`.
 * @returns {Promise<void>} A promise that resolves when all animations are finished.
 */
function onAnimationEnd(elements, callback, options = {
  subtree: true
}) {
  const animations = Array.isArray(elements) ? elements.flatMap(element => element.getAnimations(options)) : elements.getAnimations(options);
  const animationPromises = animations.reduce((acc, animation) => {
    // Ignore ViewTimeline animations
    if (animation.timeline instanceof DocumentTimeline) {
      acc.push(animation.finished);
    }
    return acc;
  }, /** @type {Promise<Animation>[]} */[]);
  return Promise.allSettled(animationPromises).then(callback);
}

/**
 * Check if the click is outside the element.
 * @param {MouseEvent} event The mouse event.
 * @param {Element} element The element to check.
 * @returns {boolean} True if the click is outside the element, false otherwise.
 */
function isClickedOutside(event, element) {
  if (event.target instanceof HTMLDialogElement || !(event.target instanceof Element)) {
    return !isPointWithinElement(event.clientX, event.clientY, element);
  }
  return !element.contains(event.target);
}

/**
 * Check if a point is within an element.
 * @param {number} x The x coordinate of the point.
 * @param {number} y The y coordinate of the point.
 * @param {Element} element The element to check.
 * @returns {boolean} True if the point is within the element, false otherwise.
 */
function isPointWithinElement(x, y, element) {
  const {
    left,
    right,
    top,
    bottom
  } = element.getBoundingClientRect();
  return x >= left && x <= right && y >= top && y <= bottom;
}

/**
 * A media query for large screens
 * @type {MediaQueryList}
 */
const mediaQueryLarge = matchMedia('(min-width: 750px)');

/**
 * Check if the current breakpoint is mobile
 * @returns {boolean} True if the current breakpoint is mobile, false otherwise
 */
function isMobileBreakpoint() {
  return !mediaQueryLarge.matches;
}

/**
 * Check if the current breakpoint is desktop
 * @returns {boolean} True if the current breakpoint is desktop, false otherwise
 */
function isDesktopBreakpoint() {
  return mediaQueryLarge.matches;
}

/**
 * Check if the device is a touch device independently ot the screen size
 * @returns {boolean} True if the device is a touch device, false otherwise
 */
function isTouchDevice() {
  return 'ontouchstart' in window && navigator.maxTouchPoints > 0;
}

/**
 * Clamps a number between a minimum and maximum value.
 * @param {number} value - The input number to clamp.
 * @param {number} min - The minimum value.
 * @param {number} max - The maximum value.
 * @returns {number} The clamped value.
 */
function clamp(value, min, max) {
  return Math.max(min, Math.min(value, max));
}

/**
 * Calculates the center point of an element along the specified axis.
 * @param {Element} element - The DOM element to find the center of.
 * @param {'x' | 'y'} [axis] - The axis ('x' or 'y') to get the center for. If not provided, returns both axes.
 * @template {('x' | 'y')} T
 * @param {T} [axis]
 * @returns {T extends ('x' | 'y') ? number : {x: number, y: number}} The center point along the axis or an object with x and y coordinates.
 */
function center(element, axis) {
  const {
    left,
    width,
    top,
    height
  } = element.getBoundingClientRect();
  const point = {
    x: left + width / 2,
    y: top + height / 2
  };
  if (axis) return /**  @type {any} */point[axis];
  return /**  @type {any} */point;
}

/**
 * Calculates the start point of an element along the specified axis.
 * @param {Element} element - The DOM element to find the start of.
 * @param {'x' | 'y'} [axis] - The axis ('x' or 'y') to get the start for. If not provided, returns both axes.
 * @returns {number | {x: number, y: number}} The start point along the axis or an object with x and y coordinates.
 */
function start(element, axis) {
  const {
    left,
    top
  } = element.getBoundingClientRect();
  const point = {
    x: left,
    y: top
  };
  if (axis) return /**  @type {any} */point[axis];
  return /**  @type {any} */point;
}

/**
 * Finds the value in an array that is closest to a target value.
 * @param {number[]} values - An array of numbers.
 * @param {number} target - The target number to find the closest value to.
 * @returns {number} The value from the array closest to the target.
 */
function closest(values, target) {
  return values.reduce(function (prev, curr) {
    return Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev;
  });
}

/**
 * Prevents the default action of an event.
 * @param {Event} event - The event to prevent the default action of.
 */
function preventDefault(event) {
  event.preventDefault();
}

/**
 * Get the visible elements within a root element.
 * @template {Element} T
 * @param {Element} root - The element within which elements should be visible.
 * @param {T[] | undefined} elements - The elements to check for visibility.
 * @param {number} [ratio=1] - The minimum percentage of the element that must be visible.
 * @param {'x' | 'y'} [axis] - Whether to only check along 'x' axis, 'y' axis, or both if undefined.
 * @returns {T[]} An array containing the visible elements.
 */
function getVisibleElements(root, elements, ratio = 1, axis) {
  if (!elements?.length) return [];
  const rootRect = root.getBoundingClientRect();
  return elements.filter(element => {
    const {
      width,
      height,
      top,
      right,
      left,
      bottom
    } = element.getBoundingClientRect();
    if (ratio < 1) {
      const intersectionLeft = Math.max(rootRect.left, left);
      const intersectionRight = Math.min(rootRect.right, right);
      const intersectionWidth = Math.max(0, intersectionRight - intersectionLeft);
      if (axis === 'x') {
        return width > 0 && intersectionWidth / width >= ratio;
      }
      const intersectionTop = Math.max(rootRect.top, top);
      const intersectionBottom = Math.min(rootRect.bottom, bottom);
      const intersectionHeight = Math.max(0, intersectionBottom - intersectionTop);
      if (axis === 'y') {
        return height > 0 && intersectionHeight / height >= ratio;
      }
      const intersectionArea = intersectionWidth * intersectionHeight;
      const elementArea = width * height;

      // Check that at least the specified ratio of the element is visible
      return elementArea > 0 && intersectionArea / elementArea >= ratio;
    }
    const isWithinX = left >= rootRect.left && right <= rootRect.right;
    if (axis === 'x') {
      return isWithinX;
    }
    const isWithinY = top >= rootRect.top && bottom <= rootRect.bottom;
    if (axis === 'y') {
      return isWithinY;
    }
    return isWithinX && isWithinY;
  });
}
function getIOSVersion() {
  const {
    userAgent
  } = navigator;
  const isIOS = /(iPhone|iPad)/i.test(userAgent);
  if (!isIOS) return null;
  const version = userAgent.match(/OS ([\d_]+)/)?.[1];
  const [major, minor] = version?.split('_') || [];
  if (!version || !major) return null;
  return {
    fullString: version.replace('_', '.'),
    major: parseInt(major, 10),
    minor: minor ? parseInt(minor, 10) : 0
  };
}

/**
 * Determines which grid items should be animated during a transition.
 * It makes an estimation based on the zoom-out card size because it's
 * the common denominator for both transition states. I.e. transitioning either
 * from 10 to 20 cards the other way around, both need 20 cards to be animated.
 * @param {Element} grid - The grid element
 * @param {Element[]} cards - The cards to animate
 * @returns {number} - Number of cards that should be animated
 */
function getCardsToAnimate(grid, cards) {
  if (!grid || !cards || cards.length === 0) return 0;
  const itemSample = cards[0];
  if (!itemSample) return 0;

  // Calculate the visible area of the grid for the Y axis. Assume X is always fully visible:
  const gridRect = grid.getBoundingClientRect();
  const visibleArea = {
    top: Math.max(0, gridRect.top),
    bottom: Math.min(window.innerHeight, gridRect.bottom)
  };
  const visibleHeight = Math.round(visibleArea.bottom - visibleArea.top);
  if (visibleHeight <= 0) return 0;

  /** @type {import('product-card').ProductCard | null} */
  const cardSample = itemSample.querySelector('product-card');
  const gridStyle = getComputedStyle(grid);
  const galleryAspectRatio = cardSample?.refs?.cardGallery?.style.getPropertyValue('--gallery-aspect-ratio') || '';
  let aspectRatio = parseFloat(galleryAspectRatio) || 0.5;
  if (galleryAspectRatio?.includes('/')) {
    const [width = '1', height = '2'] = galleryAspectRatio.split('/');
    aspectRatio = parseInt(width, 10) / parseInt(height, 10);
  }
  const cardGap = parseInt(cardSample?.refs?.productCardLink?.style.getPropertyValue('--product-card-gap') || '') || 12;
  const gridGap = parseInt(gridStyle.getPropertyValue('--product-grid-gap')) || 12;

  // Assume only a couple of lines of text in the card details (title and price).
  // If the title wraps into more lines, we might just animate more cards, but that's fine.
  const detailsSize = ((parseInt(gridStyle.fontSize) || 16) + 2) * 2;
  const isMobile = window.innerWidth < 750;

  // Always use the zoom-out state card width
  const cardWidth = isMobile ? Math.round((gridRect.width - gridGap) / 2) : 100;
  const cardHeight = Math.round(cardWidth / aspectRatio) + cardGap + detailsSize;

  // Calculate the number of cards that fit in the visible area:
  // - The width estimation is pretty accurate, we can ignore decimals.
  // - The height estimation needs to account for peeking rows, so we round up.
  const columnsInGrid = isMobile ? 2 : Math.floor((gridRect.width + gridGap) / (cardWidth + gridGap));
  const rowsInGrid = Math.ceil((visibleHeight - gridGap) / (cardHeight + gridGap));
  return columnsInGrid * rowsInGrid;
}

/**
 * Preloads an image
 * @param {string} src - The source of the image to preload
 */
function preloadImage(src) {
  const image = new Image();
  image.src = src;
}
class TextComponent extends HTMLElement {
  shimmer() {
    this.setAttribute('shimmer', '');
  }
}
if (!customElements.get('text-component')) {
  customElements.define('text-component', TextComponent);
}

/**
 * Resets the shimmer attribute on all elements in the container.
 * @param {Element} [container] - The container to reset the shimmer attribute on.
 */
function resetShimmer(container = document.body) {
  const shimmer = container.querySelectorAll('[shimmer]');
  shimmer.forEach(item => item.removeAttribute('shimmer'));
}

/**
 * Change the meta theme color of the browser.
 * @param {string} color - The color value (e.g., 'rgb(255, 255, 255)')
 */
function changeMetaThemeColor(color) {
  const metaThemeColor = document.head.querySelector('meta[name="theme-color"]');
  if (metaThemeColor && color) {
    metaThemeColor.setAttribute('content', color);
  }
}

/**
 * Gets the `view` URL search parameter value, if it exists.
 * Useful for Section Rendering API calls to get HTML markup for the correct template view.
 * Primarily used in testing alternative template views.
 * @returns {string | null} The view parameter value, or null if it doesn't exist
 */
function getViewParameterValue() {
  return new URLSearchParams(window.location.search).get('view');
}

/**
 * Helper to parse integer with a default fallback
 * Handles the case where 0 is a valid value (not falsy)
 * @template {number|null} T
 * @param {string|number|null|undefined} value - The value to parse
 * @param {T} defaultValue - The default value (number or null)
 * @returns {number|T} The parsed integer or default value
 */
function parseIntOrDefault(value, defaultValue) {
  if (value === null || value === undefined || value === '') {
    return defaultValue;
  }
  const parsed = parseInt(value.toString());
  return isNaN(parsed) ? defaultValue : parsed;
}
class Scheduler {
  /** @type {Set<() => void>} */
  #queue = new Set();
  /** @type {boolean} */
  #scheduled = false;

  /** @param {() => void} task */
  schedule = async task => {
    this.#queue.add(task);
    if (!this.#scheduled) {
      this.#scheduled = true;

      // Wait for any in-progress view transitions to finish
      if (viewTransition.current) await viewTransition.current;
      requestAnimationFrame(this.flush);
    }
  };
  flush = () => {
    for (const task of this.#queue) {
      setTimeout(task, 0);
    }
    this.#queue.clear();
    this.#scheduled = false;
  };
}
const scheduler = new Scheduler();

/**
 * Executes a callback once per session when in the Shopify theme editor
 * @param {HTMLElement} element - The element to check for the shopify editor block id
 * @param {string} sessionKeyName - Unique key for the session storage
 * @param {() => void} callback - Function to execute
 * @returns {void} - Void if the callback was executed, undefined if it wasn't
 */
function oncePerEditorSession(element, sessionKeyName, callback) {
  const isInThemeEditor = window.Shopify?.designMode;
  const shopifyEditorSectionId = JSON.parse(element.dataset.shopifyEditorSection || '{}').id;
  const shopifyEditorBlockId = JSON.parse(element.dataset.shopifyEditorBlock || '{}').id;
  const editorId = shopifyEditorSectionId || shopifyEditorBlockId;
  const uniqueSessionKey = `${sessionKeyName}-${editorId}`;
  if (isInThemeEditor && sessionStorage.getItem(uniqueSessionKey)) return;
  callback();
  if (isInThemeEditor) sessionStorage.setItem(uniqueSessionKey, 'true');
  return;
}

/**
 * A custom ResizeObserver that only calls the callback when the element is resized.
 * By default the ResizeObserver callback is called when the element is first observed.
 */
class ResizeNotifier extends ResizeObserver {
  #initialized = false;

  /**
  * @param {ResizeObserverCallback} callback
  */
  constructor(callback) {
    super(entries => {
      if (this.#initialized) return callback(entries, this);
      this.#initialized = true;
    });
  }
  disconnect() {
    this.#initialized = false;
    super.disconnect();
  }
}

/**
 * Sets the menuStyle dataset attribute on the header component element.
 * Only updates when the value actually changes to avoid layout shifts.
 */
function setHeaderMenuStyle() {
  const headerComponent = /** @type {HTMLElement} | null */document.querySelector('#header-component');
  if (!headerComponent) return;
  if (headerComponent.querySelector('.header__drawer--desktop')) {
    if (headerComponent.dataset.menuStyle !== 'drawer') {
      headerComponent.dataset.menuStyle = 'drawer';
    }
    return;
  }
  const overflowList = headerComponent.querySelector('overflow-list');
  const hasReachedMinimum = overflowList?.hasAttribute('minimum-reached') ?? false;
  const nextStyle = isTouchDevice() || hasReachedMinimum ? 'drawer' : 'menu';
  if (headerComponent.dataset.menuStyle !== nextStyle) {
    headerComponent.dataset.menuStyle = nextStyle;
  }
}

/**
 * Header group includes the header (with the menu, etc) and other sections like announcements, dividers, etc.
 * @param {HTMLElement | null} header - The header element
 * @param {HTMLElement | null} headerGroup - The header group element, defaults to the #header-group element
 * @returns {number} The height of the header group
 */
function calculateHeaderGroupHeight(header = document.querySelector('#header-component'), headerGroup = document.querySelector('#header-group')) {
  if (!headerGroup) return 0;
  let totalHeight = 0;
  const children = headerGroup.children;
  for (let i = 0; i < children.length; i++) {
    const element = children[i];
    if (element === header || !(element instanceof HTMLElement)) continue;
    totalHeight += element.offsetHeight;
  }

  // If the header is transparent and has a sibling section, add the height of the header to the total height
  if (header instanceof HTMLElement && header.hasAttribute('transparent') && header.parentElement?.nextElementSibling) {
    return totalHeight + header.offsetHeight;
  }
  return totalHeight;
}

/**
 * Updates CSS custom properties for transparent header offset calculation
 * Avoids expensive :has() selectors
 */
function updateTransparentHeaderOffset() {
  const header = document.querySelector('#header-component');
  const headerGroup = document.querySelector('#header-group');
  const hasHeaderSection = headerGroup?.querySelector('.header-section');
  if (!hasHeaderSection || !header?.hasAttribute('transparent')) {
    document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    return;
  }
  const hasImmediateSection = hasHeaderSection.nextElementSibling?.classList.contains('shopify-section');
  const shouldApplyOffset = !hasImmediateSection ? '1' : '0';
  document.body.style.setProperty('--transparent-header-offset-boolean', shouldApplyOffset);
}

/**
 * Initialize and maintain header height CSS variables.
 */
function updateHeaderHeights() {
  const header = document.querySelector('header-component');

  // Early exit if no header - nothing to do
  if (!(header instanceof HTMLElement)) return;

  // Calculate initial heights
  const headerHeight = header.offsetHeight;
  const headerGroupHeight = calculateHeaderGroupHeight(header);
  const headerTopRow = /** @type {HTMLElement} | null */header.querySelector('.header__row--top');
  document.body.style.setProperty('--header-height', `${headerHeight}px`);
  document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);
  if (headerTopRow) {
    header.style.setProperty('--top-row-height', `${headerTopRow.offsetHeight}px`);
  }
}
function updateAllHeaderCustomProperties() {
  updateHeaderHeights();
  updateTransparentHeaderOffset();
  setHeaderMenuStyle();
}

// Theme is not defined in some layouts, like the gift card page
if (typeof Theme !== 'undefined') {
  Theme.utilities = {
    ...Theme.utilities,
    scheduler: scheduler
  };
}

/***/ }),

/***/ 7198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   mq: function() { return /* binding */ DialogComponent; },
/* harmony export */   ni: function() { return /* binding */ DialogOpenEvent; },
/* harmony export */   vF: function() { return /* binding */ DialogCloseEvent; }
/* harmony export */ });
/* harmony import */ var _theme_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2443);
/* harmony import */ var _theme_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6816);



/**
 * A custom element that manages a dialog.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog – The dialog element.
 *
 * @extends Component<Refs>
 */
class DialogComponent extends _theme_component__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .u {
  requiredRefs = ['dialog'];
  connectedCallback() {
    super.connectedCallback();
    this.refs.dialog?.addEventListener('close', this.#unlockPageScroll);
    if (this.minWidth || this.maxWidth) {
      window.addEventListener('resize', this.#handleResize);
    }
    this.addEventListener('pointerdown', this.#handleProductColorSelection);
    this.addEventListener('keydown', this.#handleProductColorSelection);
    const openHash = this.getAttribute('open-on-hash');
    if (openHash && window.location.hash === `#${openHash}` && !window.Shopify?.designMode) {
      this.showDialog();
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }
  disconnectedCallback() {
    this.refs.dialog?.removeEventListener('close', this.#unlockPageScroll);
    // Section morph can remove the dialog while it is still locking the page.
    this.#unlockPageScroll();
    super.disconnectedCallback();
    if (this.minWidth || this.maxWidth) {
      window.removeEventListener('resize', this.#handleResize);
    }
    this.removeEventListener('pointerdown', this.#handleProductColorSelection);
    this.removeEventListener('keydown', this.#handleProductColorSelection);
  }

  /**
  * Updates the selected color as soon as its navigation is initiated.
  *
  * @param {PointerEvent | KeyboardEvent} event
  */
  #handleProductColorSelection = event => {
    if (!(event.target instanceof Element)) return;
    if (event instanceof PointerEvent) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    } else if (event.key !== 'Enter') {
      return;
    }
    const link = event.target.closest('.product-variation-list a.variation-link');
    if (!(link instanceof HTMLAnchorElement)) return;
    this.querySelectorAll('.product-variation-list .variation-link').forEach(variation => {
      variation.closest('.product-variation-list')?.classList.add('is-color-navigating');
      const isSelected = variation instanceof HTMLAnchorElement && variation.href === link.href;
      variation.classList.toggle('selected', isSelected);
    });
  };
  #handleResize = (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .debounce */ .sg)(() => {
    const {
      minWidth,
      maxWidth
    } = this;
    if (!minWidth && !maxWidth) return;
    const windowWidth = window.innerWidth;
    if (windowWidth < minWidth || windowWidth > maxWidth) {
      this.closeDialog();
    }
  }, 50);
  #previousScrollY = 0;

  /** @type {boolean} */
  #scrollLocked = false;

  /**
  * Releases the body scroll lock applied in showDialog.
  */
  #unlockPageScroll = () => {
    if (!this.#scrollLocked) return;
    this.#scrollLocked = false;
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo({
      top: this.#previousScrollY,
      behavior: 'instant'
    });
  };

  /**
   * Resets scroll position for nested scroll containers (e.g. facets drawer filters).
   */
  #resetContainedScrollPosition() {
    const scrollContainer = this.querySelector('.facets-drawer__filters');
    if (scrollContainer instanceof HTMLElement) {
      scrollContainer.scrollTop = 0;
    }
  }

  /**
  * Shows the dialog.
  */
  showDialog() {
    const {
      dialog
    } = this.refs;
    if (!dialog || dialog.open) return;
    const scrollY = window.scrollY;
    this.#previousScrollY = scrollY;

    // Prevent layout thrashing by separating DOM reads from DOM writes
    requestAnimationFrame(() => {
      if (!this.isConnected || !dialog.isConnected) return;
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      this.#scrollLocked = true;
      dialog.showModal();
      const initialFocus = dialog.querySelector('[data-dialog-initial-focus]') || dialog.querySelector('[autofocus]') || dialog;
      if (initialFocus instanceof HTMLElement) {
        initialFocus.focus({
          preventScroll: true
        });
      }
      this.#resetContainedScrollPosition();
      this.dispatchEvent(new DialogOpenEvent());
      this.addEventListener('click', this.#handleClick);
      this.addEventListener('keydown', this.#handleKeyDown);
    });
  }

  /**
  * Closes the dialog.
  */
  closeDialog = async () => {
    const {
      dialog
    } = this.refs;
    if (!dialog?.open) return;
    this.removeEventListener('click', this.#handleClick);
    this.removeEventListener('keydown', this.#handleKeyDown);

    // Force browser to restart animation by resetting it
    // Temporarily remove any existing animation state
    dialog.style.animation = 'none';

    // Force a reflow
    void dialog.offsetWidth;

    // Now add the closing class and restore animation
    dialog.classList.add('dialog-closing');
    dialog.style.animation = '';
    await (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .onAnimationEnd */ .$6)(dialog, undefined, {
      subtree: false
    });
    this.#unlockPageScroll();
    this.#resetContainedScrollPosition();
    dialog.close();
    dialog.classList.remove('dialog-closing');
    this.dispatchEvent(new DialogCloseEvent());
  };

  /**
  * Toggles the dialog.
  */
  toggleDialog = () => {
    const {
      dialog
    } = this.refs;
    if (dialog?.open) {
      this.closeDialog();
    } else {
      this.showDialog();
    }
  };

  /**
  * Closes the dialog when the user clicks outside of it.
  *
  * @param {MouseEvent} event - The mouse event.
  */
  #handleClick(event) {
    const {
      dialog
    } = this.refs;
    if (dialog && (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .isClickedOutside */ .lm)(event, dialog)) {
      this.closeDialog();
    }
  }

  /**
  * Closes the dialog when the user presses the escape key.
  *
  * @param {KeyboardEvent} event - The keyboard event.
  */
  #handleKeyDown(event) {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    this.closeDialog();
  }

  /**
  * Gets the minimum width of the dialog.
  *
  * @returns {number} The minimum width of the dialog.
  */
  get minWidth() {
    return Number(this.getAttribute('dialog-active-min-width'));
  }

  /**
  * Gets the maximum width of the dialog.
  *
  * @returns {number} The maximum width of the dialog.
  */
  get maxWidth() {
    return Number(this.getAttribute('dialog-active-max-width'));
  }
}
if (!customElements.get('dialog-component')) customElements.define('dialog-component', DialogComponent);
class DialogOpenEvent extends CustomEvent {
  constructor() {
    super(DialogOpenEvent.eventName);
  }
  static eventName = 'dialog:open';
}
class DialogCloseEvent extends CustomEvent {
  constructor() {
    super(DialogCloseEvent.eventName);
  }
  static eventName = 'dialog:close';
}
document.addEventListener('toggle', event => {
  if (event.target instanceof HTMLDetailsElement) {
    if (event.target.hasAttribute('scroll-lock')) {
      const {
        open
      } = event.target;
      if (open) {
        document.documentElement.setAttribute('scroll-lock', '');
      } else {
        document.documentElement.removeAttribute('scroll-lock');
      }
    }
  }
}, {
  capture: true
});

/***/ }),

/***/ 9314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I: function() { return /* binding */ MORPH_OPTIONS; },
/* harmony export */   r: function() { return /* binding */ morph; }
/* harmony export */ });
/* harmony import */ var _theme_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2443);


/**
 * @typedef {Object} Options
 * @property {boolean} [childrenOnly] - Only update children
 * @property {(node: Node | undefined) => string|number|undefined} [getNodeKey] - Get node key for matching
 * @property {(oldNode: Node, newNode: Node) => void} [onBeforeUpdate] - Pre-update hook
 * @property {(node: Node) => void} [onAfterUpdate] - Post-update hook
 * @property {(oldNode: Node, newNode: Node) => boolean} [reject] - Reject a node from being morphed
 * @property {boolean} [hydrationMode] - If true, only morph subtrees whose elements have `data-hydration-key="<non-empty>"`, matched by that value
 */

const HYDRATION_KEY_ATTRIBUTE = 'data-hydration-key';

/**
 * The options for the morph
 * @type {Options}
 */
const MORPH_OPTIONS = {
  childrenOnly: true,
  hydrationMode: false,
  reject(oldNode, newNode) {
    if (newNode.nodeType === Node.TEXT_NODE && newNode.nodeValue?.trim() === '') {
      return true;
    }
    if (newNode instanceof HTMLTemplateElement && newNode.shadowRootMode === 'open' && oldNode.parentElement && newNode.parentElement && oldNode.parentElement.tagName === newNode.parentElement.tagName && oldNode.parentElement?.shadowRoot != null) {
      // Ignore template elements of components that are already initialized
      return true;
    }
    if (newNode.nodeType === Node.COMMENT_NODE && newNode.nodeValue === 'shopify:rendered_by_section_api') {
      // Remove a comment node injected by the Section Rendering API in the Theme Editor
      return true;
    }
    return false;
  },
  onBeforeUpdate(oldNode, newNode) {
    if (oldNode instanceof Element && newNode instanceof Element) {
      const attributes = ['product-grid-view', 'data-current-checked', 'data-previous-checked', 'cart-summary-sticky'];
      for (const attribute of attributes) {
        const oldValue = oldNode.getAttribute(attribute);
        const newValue = newNode.getAttribute(attribute);
        if (oldValue && oldValue !== newValue) {
          newNode.setAttribute(attribute, oldValue);
        }
      }

      // Special case for elements that need to keep their style
      const elements = ['floating-panel-component', 'fieldset.variant-option'];
      const ids = ['account-popover'];
      for (const element of elements) {
        if (oldNode.matches(element) && newNode.matches(element)) {
          const oldStyle = oldNode.getAttribute('style');
          if (oldStyle) newNode.setAttribute('style', oldStyle);
        }
      }
      for (const id of ids) {
        if (oldNode.id === id && newNode.id === id) {
          const oldStyle = oldNode.getAttribute('style');
          if (oldStyle) newNode.setAttribute('style', oldStyle);
        }
      }

      // Preserve temporary view transition name
      if (oldNode instanceof HTMLElement && newNode instanceof HTMLElement && oldNode.style.viewTransitionName) {
        newNode.style.viewTransitionName = oldNode.style.viewTransitionName;
      }
    }
  },
  onAfterUpdate(node) {
    if (node instanceof _theme_component__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .u) {
      queueMicrotask(() => node.updatedCallback());
    }
  }
};

/**
 * Morphs one DOM tree into another by comparing nodes and applying minimal changes
 * @param {Node} oldTree - The existing DOM tree
 * @param {Node | string} newTree - The new DOM tree to morph to
 * @param {Options} [options] - Configuration options
 * @returns {Node} The morphed DOM tree
 */
function morph(oldTree, newTree, options = MORPH_OPTIONS) {
  if (!oldTree || !newTree) {
    throw new Error('Both oldTree and newTree must be provided');
  }
  if (typeof newTree === 'string') {
    const parsedNewTree = new DOMParser().parseFromString(newTree, 'text/html').body.firstChild;
    if (!parsedNewTree) {
      throw new Error('newTree string is not valid HTML');
    }
    newTree = parsedNewTree;
  }
  if (options.hydrationMode && oldTree instanceof Element && newTree instanceof Element) {
    morphHydrationByKey(oldTree, newTree, options);
    return oldTree;
  }
  if (options.childrenOnly) {
    updateChildren(newTree, oldTree, options);
    return oldTree;
  }
  if (newTree.nodeType === 11) {
    throw new Error('newTree should have one root node (not a DocumentFragment)');
  }
  return walk(newTree, oldTree, options);
}

/**
 * Collect targets under a root element that have a non-empty key for the attribute.
 * Includes the root itself if it matches.
 *
 * @param {Element} root
 * @returns {Element[]}
 */
function collectHydrationTargets(root) {
  const targets = [];
  if (root.hasAttribute(HYDRATION_KEY_ATTRIBUTE)) targets.push(root);
  targets.push(...root.querySelectorAll(`[${HYDRATION_KEY_ATTRIBUTE}]`));
  return targets;
}

/**
 * Morph only keyed targets from `newRoot` into `oldRoot` (a.k.a. "keyed lazy hydration").
 *
 * Philosophy:
 * - This updates the *contents* of pre-existing targets. We intentionally do NOT insert new targets (or remove missing ones).
 * - By requiring targets to already exist in `oldRoot`, we preserve runtime state that may already
 *   be attached to the existing DOM (custom elements, listeners, focus, transient UI state) and preserve the layout and UI behavior.
 * - Intended use-case: avoid expensive server-side rendering operations in the initial render, and hydrate targeted sections after page load. e.g. Querying all product and collection drops in off-screen menus.
 *
 * Contract:
 * - An element is eligible only if it has `data-hydration-key="<non-empty>"`.
 * - Matching uses ONLY that key value (no fallbacks) to avoid accidental cross-updates.
 * - Once a target is matched, we run a normal morph *within that target* (attributes + children).
 *
 * @param {Element} oldRoot
 * @param {Element} newRoot
 * @param {Options} options
 */
function morphHydrationByKey(oldRoot, newRoot, options) {
  const oldTargets = collectHydrationTargets(oldRoot);
  const newTargets = collectHydrationTargets(newRoot);

  /** @type {Map<string, Element[]>} */
  const oldTargetsByKey = new Map();
  for (const oldTarget of oldTargets) {
    const key = oldTarget.getAttribute(HYDRATION_KEY_ATTRIBUTE);
    if (key == null || key === '') continue;
    const existing = oldTargetsByKey.get(key) ?? [];
    existing.push(oldTarget);
    oldTargetsByKey.set(key, existing);
  }
  for (const newTarget of newTargets) {
    const key = newTarget.getAttribute(HYDRATION_KEY_ATTRIBUTE);
    if (key == null || key === '') continue;
    const matches = oldTargetsByKey.get(key);
    const oldTarget = matches?.shift();
    if (!oldTarget) continue;

    // For keyed targets we want attribute updates as well, regardless of the caller's childrenOnly default.
    morph(oldTarget, newTarget, {
      ...options,
      hydrationMode: false,
      childrenOnly: false
    });
  }
}

/**
 * Walk and morph a dom tree
 * @param {Node} newNode - The new node to morph to
 * @param {Node} oldNode - The old node to morph from
 * @param {Options} options - The options object
 * @returns {Node} The new node or the morphed old node
 */
function walk(newNode, oldNode, options) {
  // Skip morphing if there is no old or new node
  if (!oldNode) return newNode;
  if (!newNode) return oldNode;

  // Skip morphing if nodes are identical
  if (newNode.isSameNode?.(oldNode)) return oldNode;

  // Check node type and tag name first
  if (newNode.nodeType !== oldNode.nodeType) return newNode;
  if (newNode instanceof Element && oldNode instanceof Element) {
    // Skip morphing if the node is shopify-accelerated-checkout-cart https://shopify.dev/docs/storefronts/themes/pricing-payments/accelerated-checkout#implement-accelerated-checkout-buttons-on-cart
    if (oldNode.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART') return oldNode;
    if (newNode.tagName !== oldNode.tagName) return newNode;

    // Only check keys for elements, and only if both nodes have keys
    const newKey = getNodeKey(newNode, options);
    const oldKey = getNodeKey(oldNode, options);
    if (newKey && oldKey && newKey !== oldKey) return newNode;
  }

  // We can morph, update the node and its children
  if (oldNode instanceof Element && oldNode.hasAttribute('data-skip-node-update') && newNode instanceof Element && newNode.hasAttribute('data-skip-node-update')) {
    // This is a special case where we don't want to morph the node, but we want to morph the children
    updateChildren(newNode, oldNode, options);
  } else {
    updateNode(newNode, oldNode, options);
    updateChildren(newNode, oldNode, options);
  }
  options.onAfterUpdate?.(newNode);
  return oldNode;
}

/**
 * Core morphing function that updates attributes and special elements
 * @param {Node} newNode - Source node with desired state
 * @param {Node} oldNode - Target node to update
 * @param {Options} options - The options object
 */
function updateNode(newNode, oldNode, options) {
  options.onBeforeUpdate?.(oldNode, newNode);
  if (newNode instanceof HTMLDetailsElement && oldNode instanceof HTMLDetailsElement || newNode instanceof HTMLDialogElement && oldNode instanceof HTMLDialogElement) {
    if (!newNode.hasAttribute('declarative-open')) {
      newNode.open = oldNode.open;
    }
  }
  if (oldNode instanceof HTMLElement && newNode instanceof HTMLElement) {
    for (const attr of ['slot', 'sizes']) {
      const oldValue = oldNode.getAttribute(attr);
      const newValue = newNode.getAttribute(attr);
      if (oldValue !== newValue) {
        oldValue == null ? newNode.removeAttribute(attr) : newNode.setAttribute(attr, oldValue);
      }
    }
  }
  if (newNode instanceof Element && oldNode instanceof Element) {
    if (!oldNode.isEqualNode(newNode)) {
      copyAttributes(newNode, oldNode);
    }
  } else if (newNode instanceof Text || newNode instanceof Comment) {
    if (oldNode.nodeValue !== newNode.nodeValue) {
      oldNode.nodeValue = newNode.nodeValue;
    }
  }

  // Handle special elements
  if (newNode instanceof HTMLInputElement && oldNode instanceof HTMLInputElement) {
    updateInput(newNode, oldNode);
  } else if (newNode instanceof HTMLOptionElement && oldNode instanceof HTMLOptionElement) {
    updateAttribute(newNode, oldNode, 'selected');
  } else if (newNode instanceof HTMLTextAreaElement && oldNode instanceof HTMLTextAreaElement) {
    updateTextarea(newNode, oldNode);
  }
}

/**
 * Gets a node's key using the getNodeKey option if provided
 * @param {Node | undefined} node - The node to get the key from
 * @param {Options} [options] - The options object that may contain getNodeKey
 * @returns {string|number|undefined} The node's key if one exists
 */
function getNodeKey(node, options) {
  return options?.getNodeKey?.(node) ?? (node instanceof Element ? node.id : undefined);
}

/**
 * Updates a boolean attribute and its corresponding property on an element
 * @param {any} newNode - The new element
 * @param {any} oldNode - The existing element to update
 * @param {string} name - The name of the attribute/property to update
 */
function updateAttribute(newNode, oldNode, name) {
  if (newNode[name] !== oldNode[name]) {
    oldNode[name] = newNode[name];
    if (newNode[name] != null) {
      oldNode.setAttribute(name, '');
    } else {
      oldNode.removeAttribute(name);
    }
  }
}

/**
 * Copies attributes from a new node to an old node, handling namespaced attributes
 * @param {Element} newNode - The new node to copy attributes from
 * @param {Element} oldNode - The existing node to update attributes on
 */
function copyAttributes(newNode, oldNode) {
  const oldAttrs = oldNode.attributes;
  const newAttrs = newNode.attributes;

  // Update or add new attributes
  for (const attr of Array.from(newAttrs)) {
    const {
      name: attrName,
      namespaceURI: attrNamespaceURI,
      value: attrValue
    } = attr;
    const localName = attr.localName || attrName;
    if (attrName === 'src' || attrName === 'href' || attrName === 'srcset' || attrName === 'poster') {
      // Skip updating resource attributes when the value hasn't changed
      // to prevent unnecessary network requests
      if (oldNode.getAttribute(attrName) === attrValue) continue;
    }
    if (attrNamespaceURI) {
      const fromValue = oldNode.getAttributeNS(attrNamespaceURI, localName);
      if (fromValue !== attrValue) {
        oldNode.setAttributeNS(attrNamespaceURI, localName, attrValue);
      }
    } else {
      if (!oldNode.hasAttribute(attrName)) {
        oldNode.setAttribute(attrName, attrValue);
      } else {
        const fromValue = oldNode.getAttribute(attrName);
        if (fromValue !== attrValue) {
          if (attrValue === 'null' || attrValue === 'undefined') {
            oldNode.removeAttribute(attrName);
          } else {
            oldNode.setAttribute(attrName, attrValue);
          }
        }
      }
    }
  }

  // Remove old attributes not present in new node
  for (const attr of Array.from(oldAttrs)) {
    if (attr.specified === false) continue;
    const {
      name: attrName,
      namespaceURI: attrNamespaceURI
    } = attr;
    const localName = attr.localName || attrName;
    if (attrNamespaceURI) {
      if (!newNode.hasAttributeNS(attrNamespaceURI, localName)) {
        oldNode.removeAttributeNS(attrNamespaceURI, localName);
      }
    } else if (!newNode.hasAttribute(attrName)) {
      oldNode.removeAttribute(attrName);
    }
  }
}

/**
 * Updates special properties and attributes on input elements
 * Handles checked, disabled, indeterminate states and value
 * @param {HTMLInputElement} newNode - The new input element
 * @param {HTMLInputElement} oldNode - The existing input element to update
 */
function updateInput(newNode, oldNode) {
  const newValue = newNode.value;
  updateAttribute(newNode, oldNode, 'checked');
  updateAttribute(newNode, oldNode, 'disabled');

  // Handle indeterminate state (cannot be set via HTML attribute)
  if (newNode.indeterminate !== oldNode.indeterminate) {
    oldNode.indeterminate = newNode.indeterminate;
  }

  // Skip file inputs since they can't be changed programmatically
  if (oldNode.type === 'file') return;
  if (newValue !== oldNode.value) {
    oldNode.setAttribute('value', newValue);
    oldNode.value = newValue;
  }
  if (newValue === 'null') {
    oldNode.value = '';
    oldNode.removeAttribute('value');
  }
  if (!newNode.hasAttributeNS(null, 'value')) {
    oldNode.removeAttribute('value');
  } else if (oldNode.type === 'range') {
    // Update range input UI
    oldNode.value = newValue;
  }
}

/**
 * Updates the value of a textarea element
 * @param {HTMLTextAreaElement} newNode - The new textarea element
 * @param {HTMLTextAreaElement} oldNode - The existing textarea element to update
 */
function updateTextarea(newNode, oldNode) {
  const newValue = newNode.value;
  if (newValue !== oldNode.value) {
    oldNode.value = newValue;
  }
  const firstChild = oldNode.firstChild;
  if (firstChild?.nodeType === Node.TEXT_NODE) {
    if (newValue === '' && firstChild.nodeValue === oldNode.placeholder) {
      return;
    }
    firstChild.nodeValue = newValue;
  }
}

/**
 * If app scripts store references to the DOM on initialization, they will be invalidated by the morph because browsers don't re-execute them.
 * This function removes and recreates them to force re-execution.
 * @param {Element} container - The container element to search for app block scripts
 */
function recreateAppBlockScripts(container) {
  const scripts = container.querySelectorAll('.shopify-app-block script[src]');
  for (const script of scripts) {
    if (!(script instanceof HTMLScriptElement)) continue;
    const parent = script.parentElement;
    if (!parent) continue;
    const newScript = document.createElement('script');
    for (const attr of Array.from(script.attributes)) {
      newScript.setAttribute(attr.name, attr.value);
    }
    if (script.textContent) {
      newScript.textContent = script.textContent;
    }
    script.remove();
    parent.appendChild(newScript);
  }
}

/**
 * Update the children of elements
 * @param {Node} newNode - The new node to update children on
 * @param {Node} oldNode - The existing node to update children on
 * @param {Options} options - The options object
 */
function updateChildren(newNode, oldNode, options) {
  if (oldNode instanceof Element && oldNode.hasAttribute('data-skip-subtree-update') && newNode instanceof Element && newNode.hasAttribute('data-skip-subtree-update')) {
    return;
  }
  let oldChild, newChild, morphed, oldMatch;
  let offset = 0;
  for (let i = 0;; i++) {
    oldChild = oldNode.childNodes[i];
    newChild = newNode.childNodes[i - offset];

    // Both nodes are empty, do nothing
    if (!oldChild && !newChild) {
      break;
    }

    // There is no new child, remove old
    if (!newChild) {
      oldChild && oldNode.removeChild(oldChild);
      i--;
      continue;
    }

    // There is no old child, add new
    if (!oldChild) {
      oldNode.appendChild(newChild);
      offset++;
      continue;
    }

    // Both nodes are the same, morph
    if (same(newChild, oldChild, options)) {
      morphed = walk(newChild, oldChild, options);
      if (morphed !== oldChild) {
        oldNode.replaceChild(morphed, oldChild);
        offset++;
      }
      continue;
    }
    if (options.reject?.(oldChild, newChild)) {
      newNode.removeChild(newChild);
      i--;
      continue;
    }

    // Try to find a matching node to reorder
    oldMatch = null;
    for (let j = i; j < oldNode.childNodes.length; j++) {
      const potentialOldNode = oldNode.childNodes[j];
      if (potentialOldNode && same(potentialOldNode, newChild, options)) {
        oldMatch = potentialOldNode;
        break;
      }
    }
    if (oldMatch) {
      morphed = walk(newChild, oldMatch, options);
      if (morphed !== oldMatch) offset++;
      oldNode.insertBefore(morphed, oldChild);
    } else if (!getNodeKey(newChild, options) && !getNodeKey(oldChild, options)) {
      morphed = walk(newChild, oldChild, options);
      if (morphed !== oldChild) {
        oldNode.replaceChild(morphed, oldChild);
        offset++;
      }
    } else {
      oldNode.insertBefore(newChild, oldChild);
      offset++;
    }
  }

  // Recreate app block scripts to bypass browser script deduplication
  if (oldNode instanceof Element) {
    recreateAppBlockScripts(oldNode);
  }
}

/**
 * Check if two nodes are the same
 * @param {Node} a - The first node
 * @param {Node} b - The second node
 * @param {Options} options - The options object
 * @returns {boolean} True if the nodes are the same, false otherwise
 */
function same(a, b, options) {
  // If node types don't match, they're not the same
  if (a.nodeType !== b.nodeType) return false;

  // For elements, check tag name first
  if (a.nodeType === Node.ELEMENT_NODE) {
    if (a instanceof Element && b instanceof Element && a.tagName !== b.tagName) return false;

    // Only compare keys if both nodes have them
    const aKey = getNodeKey(a, options);
    const bKey = getNodeKey(b, options);
    if (aKey && bKey && aKey !== bKey) return false;
  }

  // For text/comment nodes, compare content
  if (a.nodeType === Node.TEXT_NODE && b.nodeType === Node.TEXT_NODE)
    // Trim whitespace to avoid false negatives
    return a.nodeValue?.trim() === b.nodeValue?.trim();
  if (a.nodeType === Node.COMMENT_NODE && b.nodeType === Node.COMMENT_NODE) return a.nodeValue === b.nodeValue;

  // If we get here and nodes are elements with same tag (and compatible keys), they're the same
  return true;
}

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ !function() {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = function(exports, definition) {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ }();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ !function() {
/******/ 	__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ }();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: function() { return /* binding */ QuickAddComponent; }
/* harmony export */ });
/* harmony import */ var _theme_morph__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9314);
/* harmony import */ var _theme_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2443);
/* harmony import */ var _theme_events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2375);
/* harmony import */ var _theme_dialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7198);
/* harmony import */ var _theme_utilities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6816);
/* harmony import */ var _theme_variant_picker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4919);






class QuickAddComponent extends _theme_component__WEBPACK_IMPORTED_MODULE_1__/* .Component */ .u {
  /** @type {AbortController | null} */
  #abortController = null;
  /** @type {Map<string, Element>} */
  #cachedContent = new Map();
  /** @type {AbortController} */
  #cartUpdateAbortController = new AbortController();
  get productPageUrl() {
    const productCard = /** @type {import('./product-card').ProductCard | null} */this.closest('product-card');
    const hotspotProduct = /** @type {import('./product-hotspot').ProductHotspotComponent | null} */
    this.closest('product-hotspot-component');
    const productLink = productCard?.getProductCardLink() || hotspotProduct?.getHotspotProductLink();
    if (!productLink?.href) return '';
    const url = new URL(productLink.href);
    if (url.searchParams.has('variant')) {
      return url.toString();
    }
    const selectedVariantId = this.#getSelectedVariantId();
    if (selectedVariantId) {
      url.searchParams.set('variant', selectedVariantId);
    }
    return url.toString();
  }

  /**
  * Gets the currently selected variant ID from the product card
  * @returns {string | null} The variant ID or null
  */
  #getSelectedVariantId() {
    const productCard = /** @type {import('./product-card').ProductCard | null} */this.closest('product-card');
    return productCard?.getSelectedVariantId() || null;
  }
  connectedCallback() {
    super.connectedCallback();
    _theme_utilities__WEBPACK_IMPORTED_MODULE_4__/* .mediaQueryLarge */ .GO.addEventListener('change', this.#closeQuickAddModal);
    document.addEventListener(_theme_events__WEBPACK_IMPORTED_MODULE_2__/* .ThemeEvents */ .fy.cartUpdate, this.#handleCartUpdate, {
      signal: this.#cartUpdateAbortController.signal
    });
    document.addEventListener(_theme_events__WEBPACK_IMPORTED_MODULE_2__/* .ThemeEvents */ .fy.variantSelected, this.#updateQuickAddButtonState.bind(this));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    _theme_utilities__WEBPACK_IMPORTED_MODULE_4__/* .mediaQueryLarge */ .GO.removeEventListener('change', this.#closeQuickAddModal);
    this.#abortController?.abort();
    this.#cartUpdateAbortController.abort();
    document.removeEventListener(_theme_events__WEBPACK_IMPORTED_MODULE_2__/* .ThemeEvents */ .fy.variantSelected, this.#updateQuickAddButtonState.bind(this));
  }

  /**
  * Clears the cached content when cart is updated
  */
  #handleCartUpdate = () => {
    this.#cachedContent.clear();
  };

  /**
  * Re-renders the variant picker in the quick-add modal.
  * @param {Element} newHtml - The element to re-render.
  */
  #updateVariantPicker(newHtml) {
    const modalContent = document.getElementById('quick-add-modal-content');
    if (!modalContent) return;
    const variantPicker = /** @type {VariantPicker} */modalContent.querySelector('variant-picker');
    variantPicker.updateVariantPicker(newHtml);
  }

  /**
  * Handles quick add button click
  * @param {Event} event - The click event
  */
  handleClick = async event => {
    event.preventDefault();
    const currentUrl = this.productPageUrl;

    // Check if we have cached content for this URL
    let productGrid = this.#cachedContent.get(currentUrl);
    if (!productGrid) {
      // Fetch and cache the content
      const html = await this.fetchProductPage(currentUrl);
      if (html) {
        const gridElement = html.querySelector('[data-product-grid-content]');
        if (gridElement) {
          // Cache the cloned element to avoid modifying the original
          productGrid = /** @type {Element} */gridElement.cloneNode(true);
          this.#cachedContent.set(currentUrl, productGrid);
        }
      }
    }
    if (productGrid) {
      // Use a fresh clone from the cache
      const freshContent = /** @type {Element} */productGrid.cloneNode(true);
      if (this.#getQuickAddBehavior() === 'drawer') {
        this.#applyDrawerLayout(freshContent);
      }
      this.#keepOnlyQuickAddControls(freshContent);
      await this.updateQuickAddModal(freshContent);
      this.#updateVariantPicker(productGrid);
    }
    this.#openQuickAddModal();
  };
  #resetScroll() {
    const dialogComponent = document.getElementById('quick-add-dialog');
    if (!(dialogComponent instanceof QuickAddDialog)) return;
    const productDetails = dialogComponent.querySelector('.product-details');
    const productMedia = dialogComponent.querySelector('.product-information__media');
    productDetails?.scrollTo({
      top: 0,
      behavior: 'instant'
    });
    productMedia?.scrollTo({
      top: 0,
      behavior: 'instant'
    });
  }

  /** @param {QuickAddDialog} dialogComponent */
  #stayVisibleUntilDialogCloses(dialogComponent) {
    this.toggleAttribute('stay-visible', true);
    dialogComponent.addEventListener(_theme_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogCloseEvent */ .vF.eventName, () => this.toggleAttribute('stay-visible', false), {
      once: true
    });
  }
  #openQuickAddModal = () => {
    const dialogComponent = document.getElementById('quick-add-dialog');
    if (!(dialogComponent instanceof QuickAddDialog)) return;
    dialogComponent.setBehavior(this.#getQuickAddBehavior());
    this.#stayVisibleUntilDialogCloses(dialogComponent);
    dialogComponent.addEventListener(_theme_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogOpenEvent */ .ni.eventName, () => {
      const dialog = dialogComponent.refs?.dialog;
      dialog?.focus({
        preventScroll: true
      });
    }, {
      once: true
    });
    dialogComponent.showDialog();

    // is nondeterministic when the open attribute is set on the dialog element after .showDialog() is called.
    // Waiting until the open animation starts seemed to be the most reliable metric here.
    const dialog = dialogComponent.refs?.dialog;
    if (!dialog) return;
    dialog.addEventListener('animationstart', this.#resetScroll.bind(this), {
      once: true
    });
  };
  #closeQuickAddModal = () => {
    const dialogComponent = document.getElementById('quick-add-dialog');
    if (!(dialogComponent instanceof QuickAddDialog)) return;
    dialogComponent.closeDialog();
  };
  #getQuickAddBehavior() {
    const productCard = /** @type {HTMLElement | null} */this.closest('product-card');
    const behavior = productCard?.dataset.quickAddBehavior || this.dataset.quickAddBehavior || 'default';
    return behavior === 'drawer' ? 'drawer' : 'default';
  }

  /**
  * Fetches the product page content
  * @param {string} productPageUrl - The URL of the product page to fetch
  * @returns {Promise<Document | null>}
  */
  async fetchProductPage(productPageUrl) {
    if (!productPageUrl) return null;

    // We use this to abort the previous fetch request if it's still pending.
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    try {
      const response = await fetch(productPageUrl, {
        signal: this.#abortController.signal
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch product page: HTTP error ${response.status}`);
      }
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      return html;
    } catch (error) {
      if (error.name === 'AbortError') {
        return null;
      } else {
        throw error;
      }
    } finally {
      this.#abortController = null;
    }
  }

  /**
  * Re-renders the variant picker.
  * @param {Element} productGrid - The product grid element
  */
  async updateQuickAddModal(productGrid) {
    const modalContent = document.getElementById('quick-add-modal-content');
    if (!productGrid || !modalContent) return;
    if ((0,_theme_utilities__WEBPACK_IMPORTED_MODULE_4__/* .isMobileBreakpoint */ .g1)()) {
      const productMedia = productGrid.querySelector('.product-information__media');
      const productDetails = productGrid.querySelector('.product-details');
      const productFormComponent = productGrid.querySelector('product-form-component');
      const variantPicker = productGrid.querySelector('variant-picker');
      const productPrice = productGrid.querySelector('product-price');
      const productTitle = document.createElement('a');
      productTitle.textContent = this.dataset.productTitle || '';

      // Make product title as a link to the product page
      productTitle.href = this.productPageUrl;
      const productHeader = document.createElement('div');
      productHeader.classList.add('product-header');
      const thumbnail = this.closest('product-card')?.querySelector('img');
      if (thumbnail instanceof HTMLImageElement && thumbnail.src) {
        const productThumbnail = document.createElement('img');
        productThumbnail.classList.add('product-header__thumbnail');
        productThumbnail.src = thumbnail.currentSrc || thumbnail.src;
        productThumbnail.alt = this.dataset.productTitle || thumbnail.alt || '';
        productThumbnail.loading = 'lazy';
        productHeader.appendChild(productThumbnail);
      }
      const productHeaderInfo = document.createElement('div');
      productHeaderInfo.classList.add('product-header__info');
      productHeaderInfo.appendChild(productTitle);
      if (productPrice) {
        productHeaderInfo.appendChild(productPrice);
      }
      productHeader.appendChild(productHeaderInfo);
      productGrid.appendChild(productHeader);
      if (variantPicker) {
        productGrid.appendChild(variantPicker);
      }
      if (productFormComponent) {
        productGrid.appendChild(productFormComponent);
      }
      productMedia?.remove();
      productDetails?.remove();
    }
    productGrid.querySelectorAll('[ref="zoomDialogComponent"]').forEach(el => el.remove());
    (0,_theme_morph__WEBPACK_IMPORTED_MODULE_0__/* .morph */ .r)(modalContent, productGrid);
    this.#syncVariantSelection(modalContent);
  }

  /**
  * Reorders quick-add content for drawer layout.
  * @param {Element} productGrid
  */
  #applyDrawerLayout(productGrid) {
    const grid = productGrid.querySelector('.product-information__grid');
    if (!grid) return;
    const media = grid.querySelector('.product-information__media');
    const details = grid.querySelector('.product-details');
    if (!media || !details) return;
    const title = details.querySelector('.view-product-title');
    const price = details.querySelector('product-price');
    const header = document.createElement('div');
    header.className = 'quick-add-drawer-header';
    if (title) header.appendChild(title);
    if (price) header.appendChild(price);
    const ordered = [];
    if (header.childNodes.length) ordered.push(header);
    ordered.push(media, details);
    grid.replaceChildren(...ordered);
  }

  /**
  * Keeps only quick-add-specific slideshow controls inside the modal content.
  * @param {Element} productGrid
  */
  #keepOnlyQuickAddControls(productGrid) {
    const media = productGrid.querySelector('.product-information__media');
    if (!media) return;
    media.querySelectorAll('slideshow-controls:not(.quick-add-drawer-only)').forEach(element => element.remove());
    media.querySelectorAll('slideshow-arrows:not(.quick-add-drawer-only)').forEach(element => element.remove());
  }

  /**
  * Updates the quick-add button state based on whether a swatch is selected
  * @param {VariantSelectedEvent} event - The variant selected event
  */
  #updateQuickAddButtonState(event) {
    if (!(event.target instanceof HTMLElement)) return;
    if (event.target.closest('product-card') !== this.closest('product-card')) return;
    const productOptionsCount = this.dataset.productOptionsCount;
    const quickAddButton = productOptionsCount === '1' ? 'add' : 'choose';
    this.setAttribute('data-quick-add-button', quickAddButton);
  }

  /**
  * Syncs the variant selection from the product card to the modal
  * @param {Element} modalContent - The modal content element
  */
  #syncVariantSelection(modalContent) {
    const selectedVariantId = this.#getSelectedVariantId();
    if (!selectedVariantId) return;

    // Find and check the corresponding input in the modal
    const modalInputs = modalContent.querySelectorAll('input[type="radio"][data-variant-id]');
    for (const input of modalInputs) {
      if (input instanceof HTMLInputElement && input.dataset.variantId === selectedVariantId && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
        break;
      }
    }
  }
}
if (!customElements.get('quick-add-component')) {
  customElements.define('quick-add-component', QuickAddComponent);
}
class QuickAddDialog extends _theme_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogComponent */ .mq {
  #abortController = new AbortController();

  /**
  * Updates the dialog classes (modal vs drawer).
  * @param {'default' | 'drawer'} behavior
  */
  setBehavior(behavior) {
    const {
      dialog
    } = this.refs;
    if (!dialog) return;
    const useDrawer = behavior === 'drawer' && !(0,_theme_utilities__WEBPACK_IMPORTED_MODULE_4__/* .isMobileBreakpoint */ .g1)();
    dialog.classList.toggle('quick-add-modal--drawer', useDrawer);
    dialog.classList.toggle('dialog-drawer', useDrawer);
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(_theme_events__WEBPACK_IMPORTED_MODULE_2__/* .ThemeEvents */ .fy.cartUpdate, this.handleCartUpdate, {
      signal: this.#abortController.signal
    });
    this.addEventListener(_theme_events__WEBPACK_IMPORTED_MODULE_2__/* .ThemeEvents */ .fy.variantUpdate, this.#updateProductTitleLink);
    this.addEventListener(_theme_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogCloseEvent */ .vF.eventName, this.#handleDialogClose);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
    this.removeEventListener(_theme_dialog__WEBPACK_IMPORTED_MODULE_3__/* .DialogCloseEvent */ .vF.eventName, this.#handleDialogClose);
  }

  /**
  * Closes the dialog
  * @param {CartUpdateEvent} event - The cart update event
  */
  handleCartUpdate = event => {
    if (event.detail.data.didError) return;
    this.closeDialog();
  };
  #updateProductTitleLink = (/** @type {CustomEvent} */event) => {
    const anchorElement = /** @type {HTMLAnchorElement} */
    event.detail.data.html?.querySelector('.view-product-title a');
    const viewMoreDetailsLink = /** @type {HTMLAnchorElement} */this.querySelector('.view-product-title a');
    const mobileProductTitle = /** @type {HTMLAnchorElement} */this.querySelector('.product-header a');
    if (!anchorElement) return;
    if (viewMoreDetailsLink) viewMoreDetailsLink.href = anchorElement.href;
    if (mobileProductTitle) mobileProductTitle.href = anchorElement.href;
  };
  #handleDialogClose = () => {
    const iosVersion = (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_4__/* .getIOSVersion */ .O)();
    /**
    * This is a patch to solve an issue with the UI freezing when the dialog is closed.
    * To reproduce it, use iOS 16.0.
    */
    if (!iosVersion || iosVersion.major >= 17 || iosVersion.major === 16 && iosVersion.minor >= 4) return;
    requestAnimationFrame(() => {
      /** @type {HTMLElement | null} */
      const grid = document.querySelector('#ResultsList [product-grid-view]');
      if (grid) {
        const currentWidth = grid.getBoundingClientRect().width;
        grid.style.width = `${currentWidth - 1}px`;
        requestAnimationFrame(() => {
          grid.style.width = '';
        });
      }
    });
  };
}
if (!customElements.get('quick-add-dialog')) {
  customElements.define('quick-add-dialog', QuickAddDialog);
}
var __webpack_exports__QuickAddComponent = __webpack_exports__.c;
export { __webpack_exports__QuickAddComponent as QuickAddComponent };
